import React, { useContext, useEffect, useState } from "react";
import { CheckUUID } from "../../Utility/CheckUUID";
import VisitorParamsContext from "../../Contexts/VisitorParams";
import "../../assets/css/loa2.scss";
import { userInfo } from "../../Hooks/userInfo";
import { FormData } from "../../Utility/FormData";
import { useHistory } from "react-router-dom";
import { usePreviewData } from "../../Hooks/usePreviewData";
import CoustomTd from "../Includes/Layouts/Common/CoustomTd";
let counter = 0;

const PreviewV2 = () => {
  const { isCheck } = CheckUUID();
  const isCheckResponse = isCheck();
  const { savePreviewData } = usePreviewData();
  const [showLoad, setshowLoad] = useState("show");
  const [modalShowState, setModalShowState] = useState(false);
  const [slideShow, setSlideShow] = useState("state.showSlide1");

  const [userName, setUserName] = useState();
  const [fName, setFname] = useState();
  const [lName, setLname] = useState();
  const [address, setAddress] = useState();
  const [addressLine1, setAddressLine1] = useState();
  const [addressLine2, setAddressLine2] = useState();
  const [addressLine3, setAddressLine3] = useState();
  const [city, setCity] = useState();
  const [postcode, setPostcode] = useState();
  const [phone, setPhone] = useState();
  const [county, setCounty] = useState();
  const [country, setCountry] = useState();
  const [email, setEmail] = useState();
  const [salutation, setSalutation] = useState();
  const [joineeName, setJoineeName] = useState();
  const [userDob, setUserDob] = useState();
  const [joineeDob, setJoineeDob] = useState();
  const [joineeAddress, setJoineeAdress] = useState();
  const [currentDate, setCurrentDate] = useState();
  const [userSign, setUserSign] = useState();
  const [joineeSign, setJoineeSign] = useState();
  const [partnerDate, setPartnerDate] = useState();
  const [partnerSignShow, setPartnerSignShow] = useState("hide");
  const { getUserInfo } = userInfo();
  const { visitorParameters } = useContext(VisitorParamsContext);
  const [currentUuid, setCurrentUuid] = useState();
  const [bankName, setBankName] = useState();
  const { setFormData } = FormData();
  const [userSortCode, setUserSortCode] = useState([]);
  const [userBankAccount, setUserBankAccount] = useState([]);
  const [previousAddress, setPreviousAddress] = useState();
  const history = useHistory();

  const [postcodeArr, setPostcodeArr] = useState([]);
  const [phoneArr, setPhoneArr] = useState([]);
  const [dobDateArr, setDobDateArr] = useState([]);
  const [dobMonthArr, setDobMonthArr] = useState([]);
  const [dobYearArr, setDobYearArr] = useState([]);
  useEffect(() => {
    (async () => {
      const visitorData = visitorParameters.visitor_parameters;
      if (visitorData) {
        const uuid = visitorData.uuid;
        setCurrentUuid(uuid);
      }
    })();
  }, [visitorParameters]);
  let customUuid = "";
  let customSource = "";
  const query = new URLSearchParams(window.location.search);
  const query_uuid = query.get("uuid");
  const query_source = query.get("source");
  const local_uuid = localStorage.getItem("uuid");
  customUuid = query_uuid ? query_uuid : local_uuid;
  customSource = query_source ? query_source : "live";

  const pushPageChange = () => {
    const _query = new URLSearchParams(window.location.search);
    const _query_uuid = _query.get("uuid");
    window.scrollTo(0, 0);
    history.push("/thankyou?uuid=" + _query_uuid);
  };

  const TdObj = (props) => {
    return <td className="tdp">{props.ps}</td>;
  };

  const PostcodeStr = () => {
    if (postcodeArr.length < 12) {
      let j = 12 - postcodeArr.length;
      const rows = [];
      postcodeArr.map((ps, index) => {
        rows.push(<TdObj ps={ps} key={index} />);
      });
      for (let i = 0; i < j; i++) {
        rows.push(<td key={i + "po"}>&nbsp;</td>);
      }
      return <>{rows}</>;
    } else {
      let ittration = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
      return ittration.map((ps, index) => {
        return (
          <td className="tdp" key={index}>
            &nbsp;
          </td>
        );
      });
    }
  };

  const PhoneStr = () => {
    if (phoneArr.length < 12) {
      let j = 12 - phoneArr.length;
      const rows = [];
      phoneArr.map((ps, index) => {
        rows.push(<TdObj ps={ps} key={index} />);
      });

      for (let i = 0; i < j; i++) {
        rows.push(<td key={i + "ph"}>&nbsp;</td>);
      }
      return <>{rows}</>;
    } else {
      let ittration = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
      return ittration.map((ps, index) => {
        return (
          <td className="tdp" key={index}>
            &nbsp;
          </td>
        );
      });
    }
  };

  const DobDateStr = () => {
    if (dobDateArr.length < 3) {
      return dobDateArr.map((ps, index) => {
        return (
          <td className="tdp" key={index}>
            {ps}
          </td>
        );
      });
    } else {
      let ittration = [0, 1];
      return ittration.map((ps, index) => {
        return (
          <td className="tdp" key={index}>
            &nbsp;
          </td>
        );
      });
    }
  };

  const DobMonthStr = () => {
    if (dobMonthArr.length < 3) {
      return dobMonthArr.map((ps, index) => {
        return (
          <td className="tdp" key={index}>
            {ps}
          </td>
        );
      });
    } else {
      let ittration = [0, 1];
      return ittration.map((ps, index) => {
        return (
          <td className="tdp" key={index}>
            &nbsp;
          </td>
        );
      });
    }
  };

  const DobYearStr = () => {
    if (dobYearArr.length < 5) {
      return dobYearArr.map((ps, index) => {
        return (
          <td className="tdp" key={index}>
            {ps}
          </td>
        );
      });
    } else {
      let ittration = [0, 1, 2, 3];
      return ittration.map((ps, index) => {
        return (
          <td className="tdp" key={index}>
            &nbsp;
          </td>
        );
      });
    }
  };

  useEffect(
    () => {
      const formdata = JSON.parse(localStorage.getItem("formData"));
      const customPreviousData = JSON.parse(
        localStorage.getItem("customPreviousData")
      );
      const userBank = localStorage.getItem("bankName");
      let question3 = formdata ? formdata.question_3 : "";
      if (formdata === undefined || formdata === null || formdata == "") {
        const getResult = async () => {
          let resp = await savePreviewData(customUuid);
          var result = resp.data.result;
          return result;
        };
        getResult().then((res) => {
          const postCodeArr =
            res.postcode.length > 0 ? res.postcode.split("") : [];
          const phoneArr =
            res.telephone.length > 0 ? res.telephone.split("") : [];

          let today = new Date(res.dob);
          let dob_date = String(today.getDate()).padStart(2, "0");
          let dob_month = String(today.getMonth() + 1).padStart(2, "0");
          let dob_year = String(today.getFullYear()).padStart(4, "0");

          const dobDateArr = dob_date.length > 0 ? dob_date.split("") : [];
          const dobMonthArr = dob_month.length > 0 ? dob_month.split("") : [];
          const dobYearArr = dob_year.length > 0 ? dob_year.split("") : [];

          let userAddress = "";
          if (res.address_line3 !== "") {
            userAddress =
              res.address_line1 +
              ", " +
              res.address_line3 +
              ", " +
              res.town +
              ", " +
              res.county +
              ", " +
              res.country +
              ", " +
              res.postcode.toUpperCase();
          } else {
            userAddress =
              res.address_line1 +
              ", " +
              res.town +
              ", " +
              res.county +
              ", " +
              res.country +
              ", " +
              res.postcode.toUpperCase();
          }

          setUserName(res.client_name);
          setAddress(userAddress);
          setUserDob(res.dob);
          setSalutation(res.title);
          setAddressLine1(res.address_line1);
          setAddressLine2(res.address_line3);
          setAddressLine3(res.town);
          setCity(res.town);
          setPostcode(res.postcode);
          setPhone(res.telephone);
          setCounty(res.county);
          setCountry(res.country);
          setEmail(res.email);
          setFname(res.first_name);
          setLname(res.surname);

          setUserSign(res.signature);
          let timeNow = new Date().toLocaleString();
          timeNow = timeNow.split(" ")[0].replace(/,/g, "");
          setCurrentDate(timeNow);

          setPostcodeArr(postCodeArr);
          setPhoneArr(phoneArr);
          setDobDateArr(dobDateArr);
          setDobMonthArr(dobMonthArr);
          setDobYearArr(dobYearArr);
        });
      } else {
        const userName = formdata
          ? Capitalize(formdata.txtFName) + " " + Capitalize(formdata.txtLName)
          : "";
        // const joineeName = (formdata) ? Capitalize(formdata.jointFName) + ' ' + Capitalize(formdata.jointLName) : '';
        const userdob = formdata
          ? formdata.DobDay + "/" + formdata.DobMonth + "/" + formdata.DobYear
          : "";
        const joineedob = formdata.JointDobDay
          ? formdata.JointDobDay +
            "/" +
            formdata.JointDobMonth +
            "/" +
            formdata.JointDobYear
          : "";
        const userSign = formdata ? formdata.user_sign : "";
        const lstSalutation = formdata ? formdata.lstSalutation : "";
        const addr1 = formdata ? formdata.txtHouseNumber : "";
        const addr2 = formdata ? formdata.txtAddress3 : "";
        const addr3 = formdata ? formdata.txtTown : "";
        const userCity = formdata ? formdata.txtTown : "";
        const userCounty = formdata ? formdata.txtCounty : "";
        const userCountry = formdata ? formdata.txtCountry : "";
        const ph = formdata ? formdata.txtPhone : "";
        const post = formdata ? formdata.txtPostCode.toUpperCase() : "";
        const mail = formdata ? formdata.txtEmail : "";
        const firstName = formdata ? formdata.txtFName : "";
        const lastName = formdata ? formdata.txtLName : "";

        const postCodeArr = post.length > 0 ? post.split("") : [];
        const phoneArr = ph.length > 0 ? ph.split("") : [];

        let today = new Date(userdob);
        let dob_date = String(today.getDate()).padStart(2, "0");
        let dob_month = String(today.getMonth() + 1).padStart(2, "0");
        let dob_year = String(today.getFullYear()).padStart(4, "0");

        const dobDateArr = dob_date.length > 0 ? dob_date.split("") : [];
        const dobMonthArr = dob_month.length > 0 ? dob_month.split("") : [];
        const dobYearArr = dob_year.length > 0 ? dob_year.split("") : [];

        let userAddress = "";
        if (formdata) {
          if (formdata.txtAddress3 !== "") {
            userAddress =
              formdata.txtHouseNumber +
              ", " +
              formdata.txtAddress3 +
              ", " +
              formdata.txtTown +
              ", " +
              formdata.txtCounty +
              ", " +
              formdata.txtCountry +
              ", " +
              formdata.txtPostCode.toUpperCase();
          } else {
            userAddress =
              formdata.txtHouseNumber +
              ", " +
              formdata.txtTown +
              ", " +
              formdata.txtCounty +
              ", " +
              formdata.txtCountry +
              ", " +
              formdata.txtPostCode.toUpperCase();
          }
          if (customPreviousData) {
            let preAddress = "";
            if (
              customPreviousData.previous_address_city !== "" ||
              customPreviousData.previous_address_city !== null
            ) {
              if (customPreviousData.previous_address_line1 !== null) {
                preAddress += customPreviousData.previous_address_line1;
              }
              //  preAddress += customPreviousData.previous_address_line1;
              if (customPreviousData.previous_address_line2 !== "") {
                preAddress += ", " + customPreviousData.previous_address_line2;
              }
              if (customPreviousData.previous_address_city !== "") {
                preAddress += ", " + customPreviousData.previous_address_city;
              }
              if (customPreviousData.previous_address_province !== "") {
                preAddress +=
                  ", " + customPreviousData.previous_address_province;
              }
              if (customPreviousData.previous_address_country !== "") {
                preAddress +=
                  ", " + customPreviousData.previous_address_country;
              }
              if (customPreviousData.previous_postcode_1 !== "") {
                preAddress +=
                  ", " + customPreviousData.previous_postcode_1.toUpperCase();
              }
              //preAddress += ',' + customPreviousData.previous_address_city + ',' + customPreviousData.previous_address_province + ',' + customPreviousData.previous_address_country + ',' + (customPreviousData.previous_postcode_1).toUpperCase();
              setPreviousAddress(preAddress);
            }
          }
        }
        const partnerSign = formdata ? formdata.partner_sign : "";
        setBankName(userBank);
        setUserName(userName);
        setAddress(userAddress);
        setJoineeName(joineeName);
        setUserDob(userdob);
        setJoineeDob(joineedob);
        setSalutation(lstSalutation);
        setAddressLine1(addr1);
        setAddressLine2(addr2);
        setAddressLine3(addr3);
        setCity(userCity);
        setPostcode(post);
        setPhone(ph);
        setCounty(userCounty);
        setCountry(userCountry);
        setEmail(mail);
        setFname(firstName);
        setLname(lastName);

        setPostcodeArr(postCodeArr);
        setPhoneArr(phoneArr);
        setDobDateArr(dobDateArr);
        setDobMonthArr(dobMonthArr);
        setDobYearArr(dobYearArr);

        if (question3 == 5) {
          setJoineeAdress(userAddress);
          setJoineeSign(partnerSign);
        } else {
          setJoineeAdress("");
          setJoineeSign("");
        }
        setUserSign(userSign);
        let timeNow = new Date().toLocaleString();
        timeNow = timeNow.split(" ")[0].replace(/,/g, "");
        if (question3 == 5) {
          setPartnerDate(timeNow);
          setPartnerSignShow("show");
        } else {
          setPartnerDate("");
        }
        setCurrentDate(timeNow);
      }

      const localSortcode = localStorage.getItem("sort_code");
      if (
        localSortcode != undefined &&
        localSortcode != "null" &&
        localSortcode != "" &&
        localSortcode != "Not In The List"
      ) {
        const l_SortCode = Array.from(String(localSortcode), String);
        setUserSortCode(l_SortCode);
        setModalShowState(false);
      }
      const localAccountNumber = localStorage.getItem("account_number");
      if (
        localAccountNumber != undefined &&
        localAccountNumber != "null" &&
        localAccountNumber != ""
      ) {
        const l_AccountNumber = Array.from(String(localAccountNumber), String);
        setUserBankAccount(l_AccountNumber);
        setModalShowState(false);
      }
    },
    [
      // userName,
      // userSign,
      // userDob,
      // address,
      // joineeName,
      // joineeDob,
      // joineeSign,
      // currentDate,
      // joineeAddress,
      // partnerDate,
      // partnerSignShow,
      // salutation,
    ]
  );

  function Capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }

  return (
    <>
      <div className="loa-sec2">
        <div className="body-class container">
          <section className="body_all">
            <table className="adition_page">
              <tbody>
                <tr>
                  <td>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ textAlign: "left" }}>
                            <img
                              alt=""
                              src="data:image/png;base64,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"
                            />
                          </td>
                          <td>
                            <div
                              style={{
                                textAlign: "left",
                                float: "right",
                                fontSize: "12px",
                              }}
                            >
                              1 Poole Road, Bournemouth BH2 5QQ <br />{" "}
                              Telephone: 01202 022350
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <tbody>
                        <tr>
                          <td style={{ width: "100%" }}>
                            <p
                              style={{
                                fontSize: "28px",
                                marginTop: "20px",
                                textAlign: "start",
                              }}
                            >
                              <b>Letter of Authority</b>
                            </p>
                            <p>
                              As provided for under Rule DISP2.4.16R of the FCA
                              Handbook, which states that ' A complaint may be
                              brought ont behalf of an eligible complainant, or
                              a deceased person who would have been an eligible
                              complainant, by a person authorised by law.
                            </p>
                            <table className="border" style={{ width: "100%" }}>
                              <tbody>
                                <tr style={{ backgroundColor: "#cdcdcd" }}>
                                  <th
                                    className="text-center"
                                    colSpan={2}
                                    style={{
                                      width: "100%",
                                      padding: "5px",
                                      fontSize: "13px",
                                    }}
                                  >
                                    To whom it may concern
                                  </th>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      width: "20%",
                                      border: "1px solid #000000",
                                      paddingTop: "10px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <p>
                                      <b>Bank / Lender</b>
                                    </p>
                                  </td>
                                  <td
                                    style={{
                                      width: "80%",
                                      border: "1px solid #000000",
                                    }}
                                  >
                                    <p>Moneybarn</p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <table
                              className="border"
                              style={{
                                width: "80%",
                                alignItem: "center",
                                textAlign: "center",
                                margin: "0 auto",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td style={{ border: "1px solid #000000" }}>
                                    <p style={{ marginBottom: "0px" }}>
                                      Products
                                    </p>
                                  </td>
                                  <td>
                                    <p style={{ marginBottom: "0px" }}>
                                      Loans <input type="checkbox" />
                                    </p>
                                  </td>
                                  <td>
                                    <p style={{ marginBottom: "0px" }}>
                                      Credit Cards <input type="checkbox" />
                                    </p>
                                  </td>
                                  <td>
                                    <p style={{ marginBottom: "0px" }}>
                                      Overdrafts <input type="checkbox" />
                                    </p>
                                  </td>
                                  <td>
                                    <p style={{ marginBottom: "0px" }}>
                                      Car Finance{" "}
                                      <input type="checkbox" checked />
                                    </p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <br />
                            <br />
                            <p style={{ fontSize: "12px" }}>
                              <b>Authorisation to TMS Legal Ltd:</b>
                            </p>
                            <table style={{ width: "100%" }}>
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      width: "10%",
                                      textAlign: "center",
                                    }}
                                  >
                                    <p>1.</p>
                                  </td>
                                  <td style={{ width: "90%" }}>
                                    <p>
                                      I/We have instructed TMS Legal Ltd and
                                      hereby authorise them to act on my/our
                                      behalf as solicitors in pursuing my/our
                                      claim in respect of lending from, and/or
                                      sales made by the above named company
                                      ('the company') and any other products
                                      I/we hold or have held with you
                                    </p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <p style={{ fontSize: "12px" }}>
                              <b>Instructions to the Company</b>
                            </p>
                            <table style={{ width: "100%" }}>
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      width: "10%",
                                      textAlign: "center",
                                    }}
                                  >
                                    <p>2.</p>
                                  </td>
                                  <td style={{ width: "90%" }}>
                                    <p>
                                      Please take this letter of authority as
                                      my/our instructions to you, to deal
                                      directly with TMS Legal Ltd, as my/our
                                      solicitors, in respect of the claim and to
                                      provide them with any information they
                                      request either verbally or in any other
                                      ormat in order that they may pursue my/our
                                      claim. This authority extends to providing
                                      TMS Legal Ltd with the Final Response
                                      Letter/Outcome prepared by your company.
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      width: "10%",
                                      textAlign: "center",
                                    }}
                                  >
                                    <p>3.</p>
                                  </td>
                                  <td style={{ width: "90%" }}>
                                    <p>
                                      With effect from the date I/we signed this
                                      letter of authority I/we instruct the
                                      company to adhere to my/our signed GDPR
                                      declaration on page 2 of this letter of
                                      authority in accordance with my GDPR
                                      rights.
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      width: "10%",
                                      textAlign: "center",
                                    }}
                                  >
                                    <p>4.</p>
                                  </td>
                                  <td style={{ width: "90%" }}>
                                    <p>
                                      I/We authorise and instruct TMS Legal Ltd
                                      to receive on my/our behalf any offer of
                                      redress awarded or agreed. Any cheque or
                                      electronic payments of redress should be
                                      sent to and made payable to TMS Legal Ltd
                                      who will then deduct their fees pursuant
                                      to my/our agreement with them and send
                                      me/us the balance by cheque or electronic
                                      payment.
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      width: "10%",
                                      textAlign: "center",
                                    }}
                                  >
                                    <p>5.</p>
                                  </td>
                                  <td style={{ width: "90%" }}>
                                    <p>
                                      If a copy of this Letter of Authority is
                                      provided, it will have the same validity
                                      as the original.
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      width: "10%",
                                      textAlign: "center",
                                    }}
                                  >
                                    <p>6.</p>
                                  </td>
                                  <td style={{ width: "90%" }}>
                                    <p>
                                      I/We request that you do not log the claim
                                      until you have fully approved TMS Legal
                                      Ltd's authority as we do not want to
                                      proceed without them representing us.
                                    </p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <table className="border" style={{ width: "100%" }}>
                              <tbody>
                                <tr style={{ backgroundColor: "#cdcdcd" }}>
                                  <th
                                    colSpan={3}
                                    style={{
                                      width: "50%",
                                      padding: "5px",
                                      fontSize: "13px",
                                      border: "1px solid #000000",
                                    }}
                                  >
                                    Customer 1
                                  </th>
                                  <th
                                    colSpan={3}
                                    style={{
                                      width: "50%",
                                      padding: "5px",
                                      fontSize: "13px",
                                      border: "1px solid #000000",
                                    }}
                                  >
                                    Customer 2
                                  </th>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      width: "16%",
                                      border: "1px solid #000000",
                                      paddingTop: "10px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <p>Full Name</p>
                                  </td>
                                  <td
                                    colSpan={2}
                                    style={{
                                      width: "17%",
                                      border: "1px solid #000000",
                                    }}
                                  >
                                    <p>{userName}</p>
                                  </td>
                                  <td
                                    style={{
                                      width: "16%",
                                      border: "1px solid #000000",
                                      paddingTop: "10px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <p>Full Name</p>
                                  </td>
                                  <td
                                    colSpan={2}
                                    style={{
                                      width: "17%",
                                      border: "1px solid #000000",
                                    }}
                                  >
                                    <p />
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      width: "16%",
                                      border: "1px solid #000000",
                                      paddingTop: "10px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <p>Address</p>
                                  </td>
                                  <td
                                    colSpan={2}
                                    style={{
                                      width: "17%",
                                      border: "1px solid #000000",
                                    }}
                                  >
                                    <p>{address}</p>
                                  </td>
                                  <td
                                    style={{
                                      width: "16%",
                                      border: "1px solid #000000",
                                      paddingTop: "10px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <p>Address</p>
                                  </td>
                                  <td
                                    colSpan={2}
                                    style={{
                                      width: "17%",
                                      border: "1px solid #000000",
                                    }}
                                  >
                                    <p />
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      width: "16%",
                                      border: "1px solid #000000",
                                      paddingTop: "10px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <p>Date of Birth</p>
                                  </td>
                                  <td
                                    colSpan={2}
                                    style={{
                                      width: "17%",
                                      border: "1px solid #000000",
                                    }}
                                  >
                                    <p>{userDob}</p>
                                  </td>
                                  <td
                                    style={{
                                      width: "16%",
                                      border: "1px solid #000000",
                                      paddingTop: "10px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <p>Date of Birth</p>
                                  </td>
                                  <td
                                    colSpan={2}
                                    style={{
                                      width: "17%",
                                      border: "1px solid #000000",
                                    }}
                                  >
                                    <p />
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    colSpan={2}
                                    style={{
                                      width: "16%",
                                      border: "1px solid #000000",
                                      //padding: "50px 0px 0px 0px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <img width="75%" src={userSign} />
                                    <p style={{ marginBottom: "0px" }}>
                                      SIGNATURE
                                    </p>
                                  </td>
                                  <td
                                    style={{
                                      width: "17%",
                                      border: "1px solid #000000",
                                      //padding: "50px 0px 0px 0px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <p>{currentDate}</p>
                                    <span>DATE</span>
                                  </td>
                                  <td
                                    colSpan={2}
                                    style={{
                                      width: "16%",
                                      border: "1px solid #000000",
                                      padding: "50px 0px 0px 0px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <p style={{ marginBottom: "0px" }}>
                                      SIGNATURE
                                    </p>
                                  </td>
                                  <td
                                    style={{
                                      width: "17%",
                                      border: "1px solid #000000",
                                      padding: "50px 0px 0px 0px",
                                      textAlign: "center",
                                    }}
                                  >
                                    <p style={{ marginBottom: "0px" }}>DATE</p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <br />
                            <p style={{ fontSize: "12px" }}>
                              <b> By signing this Letter of Authority: </b>
                            </p>
                            <ul>
                              <li>
                                <b>
                                  I/We agree to the terms and conditions
                                  contained in this Letter of Authority and in
                                  the Terms og Business provided.
                                </b>
                              </li>
                              <li>
                                <b>
                                  I/We agree to pay fees to TMS Legal Ltd of 45%
                                  of the total redress.
                                </b>
                              </li>
                            </ul>
                            <footer className="bg-white">
                              <div className="ft_col">
                                <div className="col">
                                  <div
                                    style={{
                                      fontSize: "11px",
                                      textAlign: "left",
                                      paddingLeft: "4%",
                                      color: "#000",
                                    }}
                                  >
                                    TMS Legal Ltd is authorised and regulated by
                                    the Solicitors Regulation Authority, Number:
                                    645041. <br />
                                    TMS Legal Ltd is a limited company
                                    registered in England and Wales, 10315962.
                                    <br />
                                    Registered Office address: 1 Poole Road,
                                    Bournemouth BH2 5QQ
                                  </div>
                                </div>
                                <div className="colb">
                                  <img
                                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARcAAAAoCAYAAADUiL4YAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAA3YSURBVHhe7ZyHd1TFF8d//5Qi0kUQkCrwk96kC/wEG016kV5EmtKRXkIaICRKSCMEQu9CEqSE3sQGzO99bt5dXpZNshtcDife7zlzdt7MvCl37v3eO7Ob/McZDAZDHGDkYjAY4gIjF4PBEBcYuRgMhrjAyMVgMMQFRi4GgyEuMHIxGAxxgZGLwWCIC4xcDAZDXGDkYjAY4gIjF4PBEBfEhVyePn3q/v77b//p34Nnz56Vu27KkcvL4p/qxxA7njx5YrKPARHJ5caNG27P3nR34cIvfkl0wLiWLF7sGtSv72q88YZr98EHbuOGDVL+uoP5kqqKnOxs17J5c+mjb58+ISX87bff3KCBA13NGjXce40auYN5eVIeK+7fvy/90H/TJk1cweHDfk10OH78uLefF/wn5/ZnZLgPWrd2qampfsmrQf7BgzLu1i1b/JLnWLpkidRdunTJL4kvRo4YIeP9+uuvfklkoL8Txo93td9+2zWoV89t37bNr3k1wKEcP3bMFRUW+iXOfbtggcz9wIEDfsnrh4jkkp2T6zZt2eYSEpP9kuiw58cfRfk7dejgvv/uO9etSxc3eNAg99dff/ktXl+8LLm0b9vWNX73Xbfuhx/cvp9/9kudW7tmjfQ7aeJEt2rlSvfHH3/4NbHhh7VrpZ85s2dLn48fP/ZrosPbb73levXo4T85t3v3bulv8+bNfsmrQeb+/TLuyhUr/JLnmD5tmtSdO3fOL4kvZs6Y4Qb07++uX7/ul0QGjoN5fTJkiOzh7du3/ZpXA8Zj/OFffOGXlOoVcz9y5Ihf8vohIrlkZucIuWz2UixRx+xZs0QIEAvv4b2DxoT3/HrqVDfR8wJJiYmhvh89eiTKhneYP2+eu3PnjpQHcfnyZTdr5kxps2njRvfnn3+6mzdvutWrVrm0tDS/lWc0u3aJ4AlhHz586L5bulTeIaJiHLB3zx63Yf16l5+fL3Mu8ZSLeZMAfaNEvPfN/Pnu3t27Uk477Q8jVyPYvGmTeLWOH34o8yFaAQUFBRLF0C+Go4pA9DJl8mQ3ccIEt2/fPikDvLvTiyR+9Eh6wTff+KXOnTx50nXt3Fn6wWOdO3tW5AeRKVgzhsvY9PNTerrb4hHHiuXLJTp56803XYv335c6IlMll4XffitrnDd3bhkPfujQITfVnyPzAb///ru8j7ExHnkFMmNOkOjkSZNkTN1f9oJ1svfIjnGVXB48eCCRwLSvv3b9+vaVOuTK3tA/a2ffT58+Lf3Rlj5oT5kCmU73ypAr+6vHx5TkZJkP7ekziOysLBnj3r17Ls+LAMjT59w5c2R+yJIoasTw4TKv4V9+GXIczIs+mUvC9u2hSDVxxw633tMtIorZ3rwhBvplb6hjLejFKe99dA+9JCoFjMX+0id2cPHiRXHMtGF81a9Hnl6fOHFC8kVFRfIun2of7A37AVSOZ86ckT1mXVoXb0Qkl4IjR4VcSPfvP/BLK0duTo4IgUT0glCU5VGYd7zjUnNPwbt36yZt2Hg25X+eR6hVs6Yb0K+fq1u7tuvVs2eZu4uznmDq1akj3pcjAe8S0tKG/ghV8eQoA+/D8BgC/fA8+OOPxfiHfvKJKOiQwYOlD+r4VM9AAqNHjpSxOIYw584dO8pYHPEwUDxYo4YNJTEmZfo+70F6ACLScox72fffCxHyzHrefecdyaMMgDzz5PP9pk2lDKCslJE4XqHMXTyyoQ8F740bO9bd8sYO9kP02Oejj0LvMz9IXsmFedEnecZkPYTgyKZ1q1auc6dOUgc5QLLktW+iUgWGwXqQdQfPCKiH6JH31ClT5FnHIaHk7BEGwzPz0jp0BeMir3uEsSIn8kRgzTw9aORFihA+86UcmbC3bbx5Q1prVq+W8r69e7ue3bu7z4YNCxEegHSoL/SOGxgmeeaBTMiP8nQsbe/e0DOf6AZERr5OrVquSePGUgepAdbDOvWdGyUlL/Sra1V5sD+AOXCVgH6xt82bNRPiCcqNd4m0VBaQHTLgyM0z7/A5cMAAsS2VY3B81v0qEJFcioqKQ+RSWFjKjNGCxWKUKkAUjY0eP26clMHgMHfbNm1EqHhzXfCxo0dDwjh96pTfowt5O9geL0jkwzPRDEpKHq+J1yeP1+VOgTzeg37xajyjuEoueGQ9svFMYuP4/Gr0aHmPewCe8daMTRkeCA9NeW5urrzPPROEFw68Be3wNOC/7doJIUJoECLKhCJBXrSrX7euzDH8KMl8qNcQvjJy4f4HklMvhewjHYtYBwan3pl5fvbpp2LUeHNk2fS994SYlVwgW/Lhc2Q/iFiILGmH7CEy8rwvEYynHzyzb0QhmgdEAjwHyWXxokUiG2SFE2EN7MGunTulngg0y4tAyONUmDOkBYj+KMdocVDh841ELugEMsOptPOOugDdoo59B4yDM2S9GDAki/yJlJUsD3tyox8id54hPCJnHBTPy5ctE7mzHp4hEdoib8YZNnSolF/xosnyjkWUIU/VMe6zgmSOLFSO2B3zgYTQjVeBiOTy4MHDELlk5ZQaTzRgYXoXgJL38CMUBIBHgznxOJoQLCEsbVCcYF1qSor0AxA0UQLKCfDcvIPi3vWUnI3t3auXKDCKzzxUcRs2aFCmX8hAyUWPSYBnEuEun5BF8D28MN6JOoyPqIh8hkdiIBpyQRHJf+yRrwJCoAy58fmRt45IqIhcMD68W5Bcvvz8c6lTlEcueueioTcKyr7RX3D97J+SC8eocLAXjIFx4d1ph5JnZmZKXgkkeOeiBk3kAYJ3LmoUepTE+HiG9ILzwkjRC6JCSJA2EDbtOe7giDT6IXLR4wuIRC4cHwARAJEbCCcX1shYCt1j5k0duqzAoKnD4QIlRT2isU88cxWA/pDn88P27SVPRFgZuSgR6RWE2hREqXKE+AAkF4yKw4Esi4sve7IrPaq9DCKSC9iTli7kwr0LoXI0QGEwbkJJhMdCWBh5Ls9QPsJbNpgo5OrVq+6XCxekzehRo8TA8Drh34SoB9IzMaE+hKJ3IdwLUI9B7EhIkDIUhjIUnA2GSPSbGiUX9XCAZxIKyTzZMJ2PRicQFZsOeenmxkIuAC+H10tPTxdDJlIhiqNP2hHCR0I4uUCmkDVHUb3sDZILkUgQGAMGQxR57dq1Csll7JgxQlwYNnvFJ/0quXAvEA7KqGM/r1y5Inlkf/78ecmzbu6Kxnz1lTyjK+wneaJKDFOdUZBclHiYB0di7p44BkCoRCyUs2ccsYlMFi1cKO+xZ8gcfWP/IUfKg3teVXLRtugaesy3NsiXOUEu6ImiPHIhQgFKLqqvHImARtpBckE3IE2IIkguGg1hJ3wjiONDN9iLWMnl3LnzYvdbtiW4a76uVRXlkssl7zik0UvewVJBVIb169aJYbIYTQgJw0Eh8LaUhZ/99OihiSiFiESBQeg9jabgtxyEvPpeUHk0PNSEwkAYFZELUGPVhCe6deuW3A3x3KpFi9DdT6zkwsUbdwXBvtU78xwtuWj0RtK7m4rIZcb06aH23bt2lUiMfCRyIdzn+Maz7hXrqIhc1FvyjRnyIY/8gR4hSbp2yIWLyeB9kEYekcgFcO8DGVPOvHAmREZqXDpX9gaDxNPzrHcWyBZdVFSVXNgDXSOJ/jXSriq5oF96RGrdsqXIkTzkAoFyH8kzCRIJkguk2t+/DNe0Yvly6T9WcrnsHcPU7iGYkpIbfk3sKJdcCI+SU3eGBrp69ZpfUzEQEgLk3I1ggpsJs2OM1BFGB+u4GaecqEePVkHIed1TLr6ZifS7BM6mfAsSDpRF+k1Lk40GtNPzcnlgDMbCw2vkxiZy98J5mjL60LkyPoYdDkiSdsFvzXg3OSlJjm5BEqVdSUmJ/1QWyJV6ZKggEsB7Q77MlzbU0y58LpRzJNm2datEFkRytFOlw/vzrITLWomu+MZJDY49oI1GjOGA5LnrwrBpp9/6sc8QKNGEjosHBoyHTLlHYS7UsU+MQT4oN0CfRAwYelBWEARz5ecQul/sL1Ew5AMJBWUHdJ6sVfdJdQQZEVkDSJA6PhXMm7EYU9sBiAddULB23lXd1PWrnNknnpEtYzNPCJU9pZy5AdpD4OgNdVqv+sfasA/WGvw9k8qR/gFzZW3lgfkePXY8ZPdbt+/w5v6iXkeDcskFwFo6SMKOpDKGYDAYqifEGRw9VoZgbnqOK1ZUSC4g+LU0BHPLY3uDwVC9AcEcLjgSsv1tCYkx236l5MIguQfyQoNwwXv8ROlXwgaDofoC2z90uCBk+9s9grkd4Qeu5aFScgEMciAvPzQIKTEpxZ04eUrOkNQbDIbqB2z7YP6h5wQTw/VIVOQCGKSouFg6D5IMaUdistuXkelycg94Uc5BS5YsVaOUk5vnUlJ3heydb5GKL1f8x54ganJRcGvNbXIkkrFkydK/I2H/lSFmclHw1VdhUZHLP3RY/j0DbBZpEpYsWap+CZuvDFUml0jgdwWWLFmqXonfJCWlpIaI5aefM174zVAk/KPkYjAYqhf4sV5i8nNi2ZexPypiAUYuBoMhIohY+FZYiSUjMyumn6AYuRgMhhfAX0XzLbASS2ZW6b8ciQVGLgaDoQzu3r0n/+JWiSUrO1fuXmKFkYvBYAiBOxb+zEeJJTun9F+kVAVGLgaDIQR+da/Ewp/9VJVYgJGLwWAIgf+Zza/tIZmX/bMeIxeDwRAXGLkYDIa4wMjFYDDEBUYuBoMhDnDu/+o7aUqsk3PZAAAAAElFTkSuQmCC"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </footer>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <div className="page-break" />
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <table className="adition_page">
              <tbody>
                <tr>
                  <td style={{ width: "100%" }}>
                    <div
                      style={{
                        height: "2px",
                        background: "#747474",
                        width: "100%",
                        margin: "40px 0 80px 0",
                      }}
                    />
                    <p
                      style={{
                        fontSize: "28px",
                        marginTop: "20px",
                        textAlign: "start",
                        marginBottom: "20px",
                      }}
                    >
                      <b>UK GDPR Notification</b>
                    </p>
                    <p style={{ fontSize: "12px" }}>
                      <b>
                        In accordance with my rights under the UK GDPR and
                        specifically Chapter II Article 6 and Chapter III
                        Articles 12, 13 and 16 therein:
                      </b>
                    </p>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ width: "5%", textAlign: "left" }}>
                            <p>
                              <b>1.</b>
                            </p>
                          </td>
                          <td style={{ width: "95%" }}>
                            <p>
                              I cuthorise my data controller at TMS Legal Ltd to
                              exchange and receive all relevent data pertaining
                              to my claim in written,electronic and verbalformat
                              with the data controller of the Lender specified
                              on this Letter of Authority.
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: "5%", textAlign: "left" }}>
                            <p>
                              <b>2.</b>
                            </p>
                          </td>
                          <td style={{ width: "95%" }}>
                            <p>
                              Any requests for information relating to my claim
                              must be made electronically to my TMS Legal Ltd
                              data controller.
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: "5%", textAlign: "left" }}>
                            <p>
                              <b>3.</b>
                            </p>
                          </td>
                          <td style={{ width: "95%" }}>
                            <p>
                              The final response letter and any other data
                              pertaining to my claim must be passed to TMS Legal
                              Ltd electronically or verbally.
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: "5%", textAlign: "left" }}>
                            <p>
                              <b>4.</b>
                            </p>
                          </td>
                          <td style={{ width: "95%" }}>
                            <p>
                              TMS Legal Ltd have verified my identity. As such
                              you must update your records in accordance with
                              their more recent data should you discover any
                              discrepancies.
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table style={{ width: "90%" }}>
                      <tbody>
                        <tr>
                          <td style={{ width: "40%" }}>
                            <p>Name</p>
                          </td>
                          <td style={{ width: "10%" }} />
                          <td style={{ width: "40%" }}>
                            <p>Name</p>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              width: "40%",
                              borderBottom: "1px solid #000000",
                              paddingTop: "10px",
                            }}
                          >
                            <p className="text-center">{userName}</p>
                          </td>
                          <td style={{ width: "10%" }} />
                          <td
                            style={{
                              width: "40%",
                              borderBottom: "1px solid #000000",
                              paddingTop: "10px",
                            }}
                          />
                        </tr>
                        <tr>
                          <td style={{ width: "40%" }}>
                            <p style={{ paddingTop: "10px" }}>Date</p>
                          </td>
                          <td style={{ width: "10%" }} />
                          <td style={{ width: "40%" }}>
                            <p style={{ paddingTop: "10px" }}>Date</p>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              width: "40%",
                              borderBottom: "1px solid #000000",
                              paddingTop: "10px",
                            }}
                          >
                            <p className="text-center">{currentDate}</p>
                          </td>
                          <td style={{ width: "10%" }} />
                          <td
                            style={{
                              width: "40%",
                              borderBottom: "1px solid #000000",
                              paddingTop: "10px",
                            }}
                          />
                        </tr>
                        <tr>
                          <td style={{ width: "40%" }}>
                            <p style={{ paddingTop: "10px" }}>Signature</p>
                          </td>
                          <td style={{ width: "10%" }} />
                          <td style={{ width: "40%" }}>
                            <p style={{ paddingTop: "10px" }}>Signature</p>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              width: "40%",
                              borderBottom: "1px solid #000000",
                              paddingTop: "10px",
                            }}
                          >
                            <img
                              src={userSign}
                              width="50%"
                              className="text-center"
                            />
                          </td>
                          <td style={{ width: "20%" }} />
                          <td
                            style={{
                              width: "40%",
                              borderBottom: "1px solid #000000",
                              paddingTop: "10px",
                            }}
                          />
                        </tr>
                      </tbody>
                    </table>
                    <p style={{ paddingTop: "15px" }}>
                      <b>
                        *Please note that the data controller for TMS Legal Ltd
                        is Nick Stocks.
                      </b>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <div className="page-break" />
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <style
              dangerouslySetInnerHTML={{
                __html:
                  "\n        .adition_page2 p {\n          font-size: 14px;\n          margin-bottom: 15px;\n        }\n\n        .adition_page2 ul li {\n          font-size: 14px;\n        }\n\n        .border-1 {\n          border: 1px solid #000000;\n          border-collapse: collapse;\n        }\n\n        .txt-1 {\n          text-align: center;\n        }\n\n        .txt-2 {\n          padding-left: 120px;\n          color: red;\n          padding-top: 20px;\n        }\n\n        .txt-3 {\n          padding-left: 100px;\n        }\n      ",
              }}
            />
            <table className="adition_page2 adition_page">
              <tbody>
                <tr>
                  <td style={{ width: "100%" }}>
                    <h4 style={{ textAlign: "center", fontSize: "20px" }}>
                      <b>TMS Legal Ltd -Terms of Business </b>
                    </h4>
                    <br />
                    <p>
                      The terms set out in the Letter of Engagement, Letter of
                      Authority, Power of Attorney, UK GDPR notification and
                      these Terms of Business are the terms and conditions on
                      which TMS Legal Ltd (‘the Company’ ‘we’ or ‘our’ or ‘us’)
                      will provide its Services to you.
                    </p>
                    <p>
                      We are a law firm authorised and regulated by the
                      Solicitors Regulation Authority. Our registration number
                      is 645041. We comply with the SRA Standards and
                      Regulations which are available on the SRA website at
                      <a href="www.sra.org.uk" style={{ color: "#000000" }}>
                        www.sra.org.uk
                      </a>
                    </p>
                    <p>
                      By agreeing to instruct us to pursue your claim on a No
                      Win No Fee basis you understand that you have the option
                      to bring a claim for redress yourself without the
                      involvement of TMS Legal Ltd.
                    </p>
                    <p>
                      <b>1. Definitions</b>
                    </p>
                    <ul>
                      <li>
                        <b> ‘Services’:</b>
                        <br />
                      </li>
                      <ul style={{ marginTop: "20px" }}>
                        <li>
                          Submitting a claim to the product provider seeking
                          redress for a mis-sold Packaged Bank Account (‘PBA’)
                        </li>
                        <li>
                          Submitting a claim to the product provider seeking
                          redress for unfair overdraft interest, fees and
                          charges
                        </li>
                        <li>
                          Submitting a claim to the product provider seeking
                          redress for unfair credit card fees, interest, charges
                          and unfair lending
                        </li>
                        <li>
                          Submitting a claim to the product provider seeking
                          redress for unfair loan fees, interest, charges and
                          unfair lending
                        </li>
                        <li>
                          Submitting a claim to the credit card provider
                          resulting from a breach of contract or
                          misrepresentation by a retailer or trader when goods
                          or services were purchased using a credit card
                        </li>
                        <li>
                          Submitting a claim to the lender/dealership for a
                          mis-sold motor finance agreement (‘MFA’)
                        </li>
                        <li>
                          Where one or more of the above claims has been
                          successful, we will seek to recover from HMRC any
                          basic rate tax deducted from the redress you receive
                        </li>
                        <li>
                          We will seek to recover from HMRC a tax rebate for
                          expenses incurred in working from home and/or having
                          to wear a uniform at work
                        </li>
                      </ul>
                      <br />
                      <br />
                      <li>
                        <b>‘Client’</b>: is ‘you’ or ‘your’
                      </li>
                      <li>
                        <b>‘Claim’</b>: is the submission of a complaint to an
                        FCA regulated entity
                      </li>
                      <li>
                        <b>‘Lender’</b>: means a bank, other financial
                        institution, building society or insurance company
                      </li>
                      <li>
                        <b>‘Dealership’</b>: is the car dealership, or other
                        intermediary, that arranged the MFA with the lender
                      </li>
                      <li>
                        <b>‘Lender/Dealership’</b>: means lender and/or
                        dealership
                      </li>
                    </ul>
                    <footer />
                  </td>
                </tr>
              </tbody>
            </table>
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <div className="page-break" />
            <table className="adition_page2 adition_page">
              <tbody>
                <tr>
                  <td style={{ width: "100%" }}>
                    <ul>
                      <li>
                        <b>‘MFA’</b> : is a motor finance agreement, such as a
                        Personal Contract purchase, Hire Purchase Agreement,
                        Conditional Sale Agreement, Hire or Lease Agreement
                      </li>
                      <li>
                        <b>‘FCA’</b> : is the Financial Conduct Authority
                      </li>
                      <li>
                        <b>‘Product Provider’</b>: means a bank, other financial
                        institution, credit card provider, building society or
                        insurance company
                      </li>
                      <li>
                        <b>‘Letter of Authority’/ Power of Attorney</b> is the
                        form you sign and return to us:
                      </li>
                      <ul>
                        <li>
                          providing written confirmation that you agree to the
                          terms and conditions upon which we are prepared to act
                          for you.
                        </li>
                        <li>
                          giving authority to us to act on your behalf in
                          relation to your claim.
                        </li>
                      </ul>
                      <li>
                        <b>‘Redress’:</b>
                      </li>
                      <ul>
                        <li>
                          is the total compensation offered by your product
                          provider or lender/dealership in response to a claim,
                          and /or
                        </li>
                        <li>
                          awarded by the Financial Ombudsman Service, and/or
                        </li>
                        <li>
                          any tax recovery which we obtain from HMRC on your
                          behalf
                        </li>
                      </ul>
                      <br />
                      <p>Redress includes some or all of the following:</p>
                      <ul>
                        <li>A refund of premium</li>
                        <li>Interest</li>
                        <li>Fees and charges</li>
                        <li>Overdraft interest</li>
                        <li>A reduction to an outstanding debt or overdraft</li>
                        <li>
                          A payment as a gesture of goodwill, or for distress
                          and inconvenience
                        </li>
                        <li>A refund of tax</li>
                        <li>Payments from a credit card company</li>
                        <li>Repair costs</li>
                        <li>Reimbursements</li>
                        <li>Refunded interest on borrowing</li>
                        <li>Reworking of a debt</li>
                        <li>
                          Removal of interest, fees and charges from an account
                        </li>
                        <li>Reduction of outstanding debt</li>
                        <li>Write-off of an outstanding balance</li>
                        <li>Compensation or other benefits received</li>
                        <li>A reduction in the interest rate</li>
                        <li>A refund of hidden or secret commission</li>
                        <li>
                          A refund of the amount you have been overcharged
                        </li>
                        <li>A waiver of any fees or charges</li>
                      </ul>
                    </ul>
                    <footer />
                  </td>
                </tr>
              </tbody>
            </table>
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <table className="adition_page">
              <tbody>
                <tr>
                  <td style={{ width: "100%" }}>
                    <ul>
                      <li>
                        <h4>
                          <b>
                            ‘Fees’: We operate on a
                            <span style={{ fontSize: "18px" }}>
                              {" "}
                              NO WIN NO FEE{" "}
                            </span>
                            basis –
                            <span style={{ fontSize: "18px" }}>
                              what does this mean?
                            </span>
                          </b>
                        </h4>
                      </li>
                      <p>
                        The fees payable to us are calculated as a percentage of
                        the redress, and are inclusive of VAT:
                      </p>
                      <ul>
                        <li>For successful claims our fees are 45%</li>
                        <li>For all tax recoveries our fees are 45%</li>
                        <li>
                          We will not charge a fee where there has been no
                          redress.
                        </li>
                      </ul>
                    </ul>
                    <br />
                    <br />
                    <p className="txt-1">
                      <b>FEE EXAMPLES</b>
                      <br />
                      <br />
                    </p>
                    <table
                      className="border-1"
                      style={{ width: "90%", margin: "0 auto" }}
                    >
                      <tbody>
                        <tr>
                          <td>
                            <p className="txt-2">
                              <b>A. Redress in the form of a CASH PAYMENT</b>
                            </p>
                            <br />
                            <p className="txt-3">
                              Let us suppose that you are offered a
                              <b>cash payment of £2000,</b> in response to your
                              PBA claim:
                            </p>
                            <br />
                            <p className="txt-3">
                              We will charge you 45% of £2000 (inclusive of VAT)
                            </p>
                            <br />
                            <p className="txt-3">
                              The fee payable will be £900 and
                              <b> you will receive £1,100</b>
                            </p>
                            <p className="txt-2">
                              <b>
                                B. Redress in the form of a REDUCTION OF A LOAN
                                OR OVERDRAFT
                              </b>
                            </p>
                            <br />
                            <p className="txt-3">
                              Let us suppose that you are offered a
                              <b>
                                £2000 reduction in the amount of your loan or
                                overdraft,
                              </b>
                              in response to your PBA claim:
                            </p>
                            <p className="txt-3">
                              We will charge you 45% of £2000 (inclusive of VAT)
                            </p>
                            <p className="txt-3">
                              The fee payable will be £900
                            </p>
                            <p className="txt-3">
                              <b>
                                Your loan or overdraft will be reduced by £2000
                              </b>
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p style={{ paddingTop: "50px" }}>
                      <b>2. Responsibilities </b>
                    </p>
                    <p style={{ paddingLeft: "10px" }}>
                      <b> We will: </b>
                    </p>
                    <ul>
                      <li>Treat you fairly and with respect</li>
                      <li>
                        Rely on the information and documents you provide us as
                        being accurate and complete
                      </li>
                      <li>
                        Pursue a claim when we have reasonable grounds to do so
                        and sufficient information on which to base it
                      </li>
                      <li>Communicate with you in plain language</li>
                      <li>Review your matter regularly</li>
                    </ul>
                    <footer />
                  </td>
                </tr>
              </tbody>
            </table>
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <div className="page-break" />
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <table className="adition_page">
              <tbody>
                <tr>
                  <td style={{ width: "100%" }}>
                    <ul>
                      <li>
                        Notify you promptly on receipt of responses from your
                        product provider
                      </li>
                    </ul>
                    <br />
                    <br />
                    <p>
                      <b>You will:</b>
                    </p>
                    <br />
                    <br />
                    <ul>
                      <li>
                        Provide us with clear and accurate information to be
                        used in pursuing a claim
                      </li>
                      <li>
                        Respond to any request for further information without
                        delay
                      </li>
                      <li>
                        Inform us immediately of any change of address or
                        contact details including email and telephone number
                      </li>
                      <li>
                        Inform us promptly should you receive a Final Response
                        Letter from the product provider or any other
                        correspondence, and send us a copy if we request it
                      </li>
                      <li>
                        Inform us promptly when redress is paid to you directly
                        by the product provider
                      </li>
                      <li>Co-operate and not mislead us</li>
                      <li>
                        Not negotiate any settlement independently of us. All
                        communications should take place between us and the
                        product provider
                      </li>
                      <li>Pay our fees where there has been redress</li>
                    </ul>
                    <br />
                    <br />
                    <p>
                      <b>3. Service levels and frequency of communication </b>
                    </p>
                    <br />
                    <br />
                    <ul>
                      <li>
                        We will update you by telephone or in writing on your
                        matter regularly. When we use the term ‘in writing’ we
                        include any form of written electronic communication
                        normally used for business purposes, such as emails and
                        texts.
                      </li>
                      <li>
                        We will explain to you the work required as your matter
                        progresses.
                      </li>
                      <li>
                        We will update you on the likely timescales for each
                        stage of the matter and update you on any material
                        change.
                      </li>
                      <li>
                        Our correspondence with you will name an individual whom
                        you can contact to discuss your claim. Alternatively,
                        you can contact the office manager on 01202 022350, or
                        by email at
                        <a
                          href="info@moneysolicitor.com"
                          style={{ color: "#000000" }}
                        >
                          info@moneysolicitor.com
                        </a>
                        who has supervisory responsibility for the claims team.
                      </li>
                    </ul>
                    <br />
                    <br />
                    <p>
                      <b>4. Cancellation of PBA Policies</b>
                    </p>
                    <br />
                    <br />
                    <ul>
                      <li>
                        In the event of a successful claim and your product
                        provider making an offer of redress the PBA benefits
                        associated with your account may be downgraded or
                        cancelled and it is your responsibility to arrange
                        replacement cover if required.
                      </li>
                    </ul>
                    <footer />
                  </td>
                </tr>
              </tbody>
            </table>
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <div className="page-break" />
            <table className="adition_page">
              <tbody>
                <tr>
                  <td style={{ width: "100%" }}>
                    <br />
                    <br />
                    <p>
                      <b>
                        5. Limit of Liability and Professional Indemnity
                        Insurance
                      </b>
                    </p>
                    <br />
                    <br />
                    <ul>
                      <li>
                        We maintain professional indemnity insurance in
                        accordance with the requirements of the Solicitors
                        Regulation Authority and a copy of our policy schedule
                        is available for inspection by clients at our office.
                        Our liability to you in respect of professional
                        negligence claims is limited to the extent of the
                        coverage we maintain.
                      </li>
                      <li>
                        Any advice given to you or work undertaken for you by a
                        director, employee or consultant of the Company will be
                        given or undertaken by that person on behalf of the
                        Company and not in his or her individual capacity. Our
                        directors, employees and consultants do not owe a
                        personal duty of care nor assume any personal
                        responsibility for their advice or other work.
                      </li>
                    </ul>
                    <br />
                    <br />
                    <p>
                      <b>6. Banking and Interest and Cash</b>
                    </p>
                    <br />
                    <br />
                    <ul>
                      <li>
                        We hold all client money in our client account with a UK
                        clearing bank which is authorised by the Prudential
                        Regulation Authority and regulated by the Financial
                        Conduct Authority and the Prudential Regulation
                        Authority. We will not be responsible for any loss due
                        to any mistake by or failure of the clearing bank.
                      </li>
                      <li>
                        When we hold money for you in our client account we will
                        pay interest to you of a fair and reasonable amount when
                        it is fair and reasonable to do so. However, we do not
                        pay interest if the amount calculated is £20 or less. We
                        will calculate interest at the end of the matter and
                        account to you promptly if any is due. The rate of
                        interest is the base rate of Barclays Bank PLC from time
                        to time.
                      </li>
                      <li>
                        Our policy is not to accept cash. If clients circumvent
                        this policy by depositing cash directly with our bank we
                        reserve the right to charge for any additional checks we
                        consider necessary regarding the source of the funds.
                      </li>
                    </ul>
                    <br />
                    <br />
                    <p>
                      <b>7. Fees </b>
                    </p>
                    <br />
                    <ul>
                      <li>We will notify you of any fees that are payable.</li>
                      <li>
                        If redress has been paid to you directly by the product
                        provider, or by the lender/dealership, or by HMRC in the
                        event of a tax recovery, payment of our fees is due
                        immediately. If the payment is outstanding for more than
                        21 days an additional £50 charge may be added to cover
                        administration and collection costs.
                      </li>
                      <li>
                        If redress is paid to us by the product provider, or by
                        the lender/dealership or by HMRC in the event of a tax
                        recovery, you agree that we can deduct our fee before
                        forwarding the balance to you.
                      </li>
                      <li>
                        We may agree a payment plan with you for up to 3 months
                        to clear an outstanding balance, but we will charge
                        simple interest at 12% per annum.
                      </li>
                      <li>
                        Should you owe us any fees you agree that we can deduct
                        this outstanding debt from any redress offered or
                        awarded by a product provider, or by a lender/dealership
                        in respect of another successful claim or by HMRC in
                        relation to a tax recovery.
                      </li>
                      <li>
                        Payment of our fees is due if redress is offered or
                        awarded following any direct communications you may have
                        had with the product provider or lender/dealership
                        subsequent to the submission of a claim by us to them.
                      </li>
                    </ul>
                    <footer />
                  </td>
                </tr>
              </tbody>
            </table>
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <div className="page-break" />
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <table className="adition_page">
              <tbody>
                <tr>
                  <td style={{ width: "100%" }}>
                    <ul>
                      <li>
                        Payment of our fees is also due if you enter into a
                        contract with another entity and redress is offered or
                        awarded following submission of a claim by us to the
                        product provider, or to the lender/dealership.
                      </li>
                      <li>
                        Should the product provider or lender/dealership
                        increase an offer at a later date, perhaps because of a
                        review of the claim or as a result of an audit, we will
                        charge fees on the additional amount on the same basis
                        and at the same percentage of the redress as previously
                        agreed.
                      </li>
                      <li>
                        Should the product provider or lender/ dealership uphold
                        other claims as a result of our approach to them we will
                        deal with these cases on your behalf and charge fees on
                        the same basis and at the same percentage of the redress
                        as previously agreed.
                      </li>
                      <li>
                        Should you have any outstanding debts at the time we
                        notify you of fees due to us you agree that we will have
                        first charge.
                      </li>
                      <li>
                        You have the right to complain about our invoice
                        directly to us (see Complaints Clause 18) and also by
                        applying to the court to assess the invoice under Part
                        111 of the Solicitors Act 1974. The usual time limit for
                        making such an application is one month from the date of
                        delivery of the invoice. If the application is made
                        after one month but before 12 months from the date of
                        delivery of the invoice, the court’s permission is
                        required for the invoice to be assessed. Unless there
                        are special circumstances, the court will not order an
                        invoice to be assessed after:
                      </li>
                      <ul>
                        <li>12 months from delivery of the invoice</li>
                        <li>
                          A judgment has been obtained for the recovery of the
                          costs covered by the invoice
                        </li>
                        <li>
                          The invoice has been paid, even if this is within 12
                          months
                        </li>
                      </ul>
                    </ul>
                    <br />
                    <br />
                    <p>
                      <b>8. Fee sharing </b>
                    </p>
                    <br />
                    <ul>
                      <li>
                        If you have been introduced to us by a third party, we
                        may share our fees with them. They will receive up to
                        50% of our fees. This has no bearing on the way we
                        handle our claim for you and our duty to act in your
                        best interests will not be compromised. The amount of
                        redress you receive will not be reduced by any fee
                        sharing agreement.
                      </li>
                    </ul>
                    <br />
                    <p>
                      <b>9. Your Personal Data and Electronic communication</b>
                    </p>
                    <br />
                    <ul>
                      <li>
                        We take the privacy of your personal data seriously. It
                        is controlled and processed in accordance with the UK
                        General Data Protection Regulation (‘UK GDPR’). You give
                        us full authority to disclose and receive information as
                        outlined herein and in our Privacy Policy which can be
                        viewed at
                        <a
                          href="www.pba-claims.co.uk"
                          style={{ color: "#000000" }}
                        >
                          www.pba-claims.co.uk.
                        </a>{" "}
                        We ask that you read our Privacy Policy carefully. If
                        required, a hard copy is available upon request. Nick
                        Stocks is the data controller for TMS Legal Ltd.
                      </li>
                      <p>
                        We use the personal data primarily for the provision of
                        legal services to you in relation <br />
                        to your claim and for related purposes including:
                      </p>
                      <ul style={{ marginLeft: "30px" }}>
                        <li>
                          Contacting you in relation to your claim and
                          responding to your enquiries
                        </li>
                        <li>Processing your claim</li>
                        <li>
                          Contacting and responding to third parties on your
                          behalf in relation to the claim, for example, product
                          providers, lenders, dealerships, and the Financial
                          Ombudsman Service and HMRC.
                        </li>
                        <li>Updating and enhancing client records</li>
                      </ul>
                    </ul>
                    <footer />
                  </td>
                </tr>
              </tbody>
            </table>
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <div className="page-break" />
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <table className="adition_page">
              <tbody>
                <tr>
                  <td style={{ width: "100%" }}>
                    <ul>
                      <ul>
                        <li>Administration and billing</li>
                        <li>Management of our business</li>
                        <li>Statutory returns</li>
                        <li>
                          Legal and regulatory compliance including auditing and
                          investigation(s)
                        </li>
                        <li>Debt collecting</li>
                        <li>
                          Prevention of fraud, money laundering and terrorism
                        </li>
                        <li>Verifying your identity and contact details</li>
                      </ul>
                      <li>
                        Please note that telephone calls are recorded for
                        quality, training and compliance purposes.
                      </li>
                      <li>
                        You agree to accept the risks of using electronic
                        communication, including but not limited to the risks of
                        viruses, interception, unauthorised access, delay,
                        misrouting and break down of service providers.
                      </li>
                    </ul>
                    <br />
                    <br />
                    <p>
                      <b>10. Storage </b>
                    </p>
                    <br />
                    <br />
                    <ul>
                      <li>
                        We hold personal data for as long as is necessary to
                        fulfil the purpose for which we collected such
                        information (or for any compatible purpose), including
                        for the purposes of satisfying any legal, accounting or
                        regulatory requirement, and limitation periods for
                        taking legal action.
                      </li>
                      <li>
                        Any original documents we obtain from you will be
                        scanned and returned to you within 14 days of receipt.
                      </li>
                    </ul>
                    <br />
                    <br />
                    <p>
                      <b>11. Prevention of Money Laundering </b>
                    </p>
                    <br />
                    <ul>
                      <li>
                        We are professionally and legally obliged to keep your
                        affairs confidential. However, solicitors may be obliged
                        by statute to make a disclosure to the National Crime
                        Agency and other relevant authorities where they know or
                        suspect that a transaction may involve money laundering
                        or terrorist financing. If we make a disclosure in
                        relation to your matter, we may not be able to tell you
                        that a disclosure has been made or the reason for it. We
                        may have to stop working on your matter and may not be
                        able to tell you why.
                      </li>
                      <li>
                        We also have to obtain satisfactory verification of the
                        identity of our clients and undertake client due
                        diligence. This may be necessary even if we have acted
                        for you before or you are personally known to us. In the
                        absence of such verification at the start of our
                        relationship we are unable to act for you. We will
                        conduct an electronic verification of your identity and
                        proof of address by searching various data sets. We may
                        additionally ask you to provide documents as proof of
                        your identity and address.
                      </li>
                    </ul>
                    <br />
                    <br />
                    <p>
                      <b>12. Confidentiality </b>
                    </p>
                    <br />
                    <ul>
                      <li>
                        Any information not in the public domain or known to us,
                        that we receive from you whilst acting for you in
                        connection with any matter, is confidential. However, in
                        some circumstances we may berequired to disclose
                        confidential information and documents to the court or
                        to regulatory or fiscal authorities. Should we be so
                        required we will, to the extent we are permitted,
                        endeavour to give you advance notice of the disclosures
                        we are obliged to make.
                      </li>
                    </ul>
                    <footer />
                  </td>
                </tr>
              </tbody>
            </table>
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <div className="page-break" />
            <table className="adition_page">
              <tbody>
                <tr>
                  <td style={{ width: "100%" }}>
                    <ul>
                      <li>
                        Please note that by accepting our terms and conditions
                        you are consenting to the inspection of your file should
                        it be selected for audit or regulatory compliance
                        checks.
                      </li>
                    </ul>
                    <p>
                      <b>13. Equality and Diversity </b>
                    </p>
                    <ul>
                      <li>
                        We are committed to the principles of equality and
                        diversity and to observing all legislative requirement
                        regarding these principles.
                      </li>
                      <li>
                        The company is committed to a policy of
                        non-discrimination, non-victimisation and nonharassment
                        in all its professional dealings with employees,
                        directors, clients and third parties and will not
                        discriminate, victimise or harass any person in these
                        groups on the grounds of: race or racial group (
                        including colour, nationality and ethnic or national
                        origins), sex (including marital status, civil
                        partnership, gender reassignment, pregnancy, maternity
                        and paternity), religion or beliefs, age or disability.
                      </li>
                    </ul>
                    <br />
                    <br />
                    <p>
                      <b>14. Vulnerability </b>
                    </p>
                    <br />
                    <ul>
                      <li>
                        We are committed to the early identification and
                        protection of vulnerable clients. A copy of our
                        vulnerability policy is available on request.
                      </li>
                    </ul>
                    <br />
                    <br />
                    <p>
                      <b>15. Conflict of Interest </b>
                    </p>
                    <br />
                    <ul>
                      <li>
                        We will check for conflicts of interest before taking on
                        work and whilst we are retained by you. Where a conflict
                        arises between your interests and the interests of
                        another client of the firm during the course of a
                        matter, we will discuss the position with you and
                        determine the appropriate course of action. In order to
                        protect your interests, we may not be permitted to
                        continue to act for you.
                      </li>
                    </ul>
                    <br />
                    <br />
                    <p>
                      <b>16. Authorisation to commence work </b>
                    </p>
                    <br />
                    <ul>
                      <li>
                        You expressly request and authorise us to begin working
                        on your claim before the end of the statutory
                        cancellation period referred to in clause 17 below. You
                        understand that by giving this authorisation you cease
                        having the right to cancel the contract if our service
                        has been fully performed.
                      </li>
                    </ul>
                    <br />
                    <p>
                      <b>17. Cancellation and Termination </b>
                    </p>
                    <br />
                    <ul>
                      <li>
                        You have the statutory right to cancel this contract
                        within 14 days of agreeing to it. You can request
                        cancellation by email at
                        <a
                          href="info@moneysolicitor.com"
                          style={{ color: "#000000" }}
                        >
                          {" "}
                          info@moneysolicitor.com
                        </a>
                        or by writing to us at TMS Legal Ltd, 1 Poole Road,
                        Bournemouth, BH2 5QQ or by using the enclosed
                        cancellation form. Use of the cancellation form is not
                        obligatory.
                      </li>
                      <li>
                        You may also cancel this contract after the statutory
                        cancellation period but our fees are still payable where
                        there has been redress - whether prior to, or subsequent
                        to, the notice of cancellation.
                      </li>
                      <li>
                        We may decide to stop acting for you, but only with good
                        reason: for example, if you do not pay an invoice, if
                        you provide us with misleading information, if you act
                        in an offensive or abusive manner, or if we conclude
                        that we have no substantive grounds on which to pursue
                        or continue a claim against a product provider, or that
                        such claim is unlikely to be successful.
                      </li>
                    </ul>
                    <footer />
                  </td>
                </tr>
              </tbody>
            </table>
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <div className="page-break" />
            <table className="adition_page">
              <tbody>
                <tr>
                  <td style={{ width: "100%" }}>
                    <p>
                      <b>18. Complaints </b>
                    </p>
                    <ul>
                      <li>
                        We endeavour to provide a good quality service with
                        efficiency and courtesy. It is our aim that our clients
                        should be satisfied with all aspects of the work
                        undertaken by us.
                      </li>
                      <li>
                        However, if you are unhappy with any aspect of our
                        service, or the amount of our invoice, please contact
                        the office manager by writing to TMS Legal Ltd, 1 Poole
                        Road, Bournemouth, BH2 5QQ or by telephone 01202 022350
                        or by email to
                        <a
                          href="info@moneysolicitor.com"
                          style={{ color: "#000000" }}
                        >
                          info@moneysolicitor.com
                        </a>
                        . A copy of our complaints handling procedure is
                        available on request
                      </li>
                      <li>
                        We undertake to investigate any complaint carefully and
                        promptly and will provide our final written response to
                        you within 8 weeks. If we have not resolved it within
                        this time you may complain to the Legal Ombudsman.
                        <p style={{ paddingTop: "10px" }}>
                          The Legal Ombudsman’s contact details are:
                        </p>
                        <ul style={{ paddingLeft: "10px" }}>
                          <li>By post: PO Box 6806, Wolverhampton, WV1 9WJ</li>
                          <li>
                            By email:
                            <a
                              href="enquiries@legalombudsman.org.uk"
                              style={{ color: "#000000" }}
                            >
                              enquiries@legalombudsman.org.uk
                            </a>
                          </li>
                          <li>By phone: 0300 555 0333</li>
                        </ul>
                      </li>
                      <li>
                        You need to bring a complaint to the Legal Ombudsman
                        within 6 months of receiving a final written response
                        from us about your complaint, provided it is within 6
                        years of the occurrence of the act or omission you are
                        complaining about (or if outside of this period, within
                        3 years of when you should reasonably have been aware of
                        it).
                      </li>
                      <li>
                        Alternative complaints bodies exist which are competent
                        to deal with complaints about legal services should both
                        you and the company wish to use such a scheme. A list of
                        those that we recommend is available on request.
                      </li>
                    </ul>
                    <p style={{ paddingTop: "20px" }}>
                      <b>19. Applicable Law</b>
                    </p>
                    <ul>
                      <li>
                        The contract and any dispute between us shall be
                        governed by and construed in accordance with the laws of
                        England and Wales and shall be subject to the exclusive
                        jurisdiction of the English courts.
                      </li>
                    </ul>
                    <p style={{ paddingBottom: "20px" }}>
                      <b>
                        I /We agree to and accept the terms and conditions set
                        out in the Terms of Business above and in the Letter of
                        Engagement, Letter of Authority, Power of Attorney and
                        UK GDPR notification
                      </b>
                    </p>

                    <div className="ft_col">
                      <div className="col">
                        <table>
                          <tbody>
                            <tr>
                              <td
                                className="border"
                                style={{
                                  width: "48%",
                                  padding: "15px",
                                  borderRadius: "30px",
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: "18px",
                                    textAlign: "center",
                                  }}
                                >
                                  <b>Client 1</b>
                                </p>
                                <p style={{ textAlign: "center" }}>
                                  Print Full Name:{" "}
                                  <span className="dotted-underline">
                                    {userName}
                                  </span>
                                </p>
                                <table style={{ width: "100%" }}>
                                  <tbody>
                                    <tr>
                                      <td>
                                        <p style={{ padding: "15px 5px 15px" }}>
                                          Signature:{" "}
                                          {/* <b style={{ fontSize: "20px" }}>x</b> */}
                                          <img width="40%" src={userSign} />
                                        </p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <p style={{ textAlign: "right" }}>
                                  (Signature required in above Box)
                                </p>
                                <p style={{ textAlign: "left" }}>
                                  Dated: {currentDate}
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="col">
                        <table>
                          <tbody>
                            <tr>
                              <td
                                className="border"
                                style={{
                                  width: "48%",
                                  padding: "15px",
                                  borderRadius: "30px",
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: "18px",
                                    textAlign: "center",
                                  }}
                                >
                                  <b>Client 1</b>
                                </p>
                                <p style={{ textAlign: "center" }}>
                                  Print Full Name: ……………………………….
                                </p>
                                <table style={{ width: "100%" }}>
                                  <tbody>
                                    <tr>
                                      <td>
                                        <p style={{ padding: "15px 5px 15px" }}>
                                          Signature:{" "}
                                          <b style={{ fontSize: "20px" }}>x</b>
                                          <img
                                            className="opacity-0"
                                            width="40%"
                                            src={userSign}
                                          />
                                        </p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <p style={{ textAlign: "right" }}>
                                  (Signature required in above Box)
                                </p>
                                <p style={{ textAlign: "left" }}>Dated:</p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            {/* /////////////////////////////////////Page///////////////////////////// */}
            {/* End Page Nine */}
            <div className="page-break" />
            <table className="adition_page">
              <tbody>
                <tr>
                  <td style={{ width: "100%" }}>
                    <p
                      style={{
                        marginTop: "20px",
                        textAlign: "center",
                        fontSize: "16px",
                      }}
                    >
                      <b>NOTICE OF RIGHT TO CANCEL</b>
                    </p>
                    <p style={{ color: "#7b7b7a" }}>
                      You have the right to cancel this contract within 14 days
                      of agreeing to it. You can request cancellation by email
                      at <br />
                      <a
                        style={{ color: "#0563c1" }}
                        href="info@moneysolicitor.com"
                      >
                        info@moneysolicitor.com
                      </a>{" "}
                      or by writing to us at TMS Legal Ltd, 1 Poole Road,
                      Bournemouth, BH2 5QQ or by using the cancellation form.
                    </p>
                    <p
                      style={{
                        borderBottom: "1px dotted #000",
                        height: "2px",
                        margin: "40px 0",
                      }}
                    />
                    <p
                      style={{
                        marginTop: "20px",
                        textAlign: "center",
                        fontSize: "16px",
                      }}
                    >
                      <b>CANCELLATION FORM </b>
                    </p>
                    <br />
                    <br />
                    <p>To: TMS Legal Ltd</p>
                    <p>
                      I / We* hereby give notice that I / We* cancel my / our*
                      contract for the supply of services by TMS Legal Ltd.
                    </p>
                    <br />
                    <br />
                    <p>Name: {userName}</p>
                    <p>Address: {address}</p>
                    <p>
                      Signature: <img width="20%" src={userSign} />
                    </p>
                    <p>Date: {currentDate}</p>
                    <br />
                    <br />
                    <p>* Delete as appropriate.</p>
                    <p>You can return this form by:</p>
                    <ul>
                      <li>
                        Post to: TMS Legal Ltd, 1 Poole Road, Bournemouth BH2
                        5QQ
                      </li>
                      <li>E mail: info@moneysolicitor.com</li>
                    </ul>
                    <br />
                    <br />
                    <br />
                  </td>
                </tr>
              </tbody>
            </table>
            {/* /////////////////////////////////////Page///////////////////////////// */}
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <table className="adition_page">
              <tbody>
                <tr>
                  <td>
                    <table className="log_hd">
                      <tbody>
                        <tr>
                          <td
                            style={{
                              textAlign: "right",
                              verticalAlign: "bottom",
                              fontSize: "12px",
                              paddingBottom: "5px",
                            }}
                          >
                            QR code for <br />
                            internal use only
                          </td>
                          <td>
                            <img
                              className="br_code"
                              src="data:image/png;base64,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"
                              alt=""
                            />
                          </td>
                          <td className="pt-logo">
                            <img
                              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAABCCAYAAACfHt50AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAA/fSURBVHhe7ZyHW5THFsbvP3JL1FhiN2A0tkRSNJZYiBpNMyYmxoYl0asCiVdzJRijYiT2EkFQ1NiwKxaMURGxY0FUEFBRBAvNzOV32IFlGdhlgXVv2Pd5zrM7/dvvvN/MmXPm278pD+o0PASo4/AQoI7DQ4A6Dg8B6jiMBJg0Lkz17/FjrciwIaFq+rQoFRV5TB2OuahuJt9Vz579aRnZA1fDSAAU1ejvfjUmbZpMUv6TIlXciST19Gm++vNPj8LdBbVKgPatp6mINbEq10bpfC8seurTHuSqCyk5Kj45S4UfTZXP8ynZlloeuAK1QoAm/xynvvFbox4/yrX0WIqsx/kqLDZFfRh6WvX56WQ5Gbo4wTNDuBA1TgCUv21zXNG6/szSWzGeFSl104k0NTDklFHxWjwEcC1qlAAtGnytDh24YOmlFEz3wduuGRVuKx4CuBY1RoDG/xin9uwsrzzS83YkGZVtEg8BXIsaI8CUCeFG5Uf8nmpUdEXiIYBrUSME6OQVqHJz8y2tS3H/UZ4aYGfNtxUPAVyLahOAqX9X9GlLy1KgxKCtV4xKrkw8BHAtqk2ANzvOUAUFhZaWpeDp950fZ1RyZeIhgGtRbQJsiDxmaVUW2+PTjQq2Jx4CuBbVIkCzehNU9sMnllalYM8/etU5o4LtiYcArkW1CDCoz1yjsh49LXBq+kc8BHAtqkUAPH4mXEzNMSrXEfEQwLVwmgAv/Wu8ykjPsrQoi+jTGUblOiLVJUBhYaFbEIhryM8vvzV2NzhNgHYtp0qUz4SAqESjch0RewTgpmZm3isneXl5UtazZw/1yScfCxGeJzZs2KDatXtFXb9+3ZJTMXJystW77/ZW8+bNteS4Dk4TYIjv/AoVNWLFWaNyHRF7BPjjjz9UvXovlJO9e/cKCXx8uqqBAwc+dwL8+uuvqnXrVurMmTOWnIrx4MED+Q1ffz3RkuM6OE0A/0kRltrlMcBJAxBxlAC9evVSW7duKZH09HQpLygoeO7KB3oJqOy3aPxfEmDBTzsttcuCLaBJsY6KowSYMWOGJacUT58+VV27dlX9+vUVEqSnp6n27dupX34JVfPnz1cvvdRENW36klq/fr3UZ5xjx44VkamnatCgvmrcuJEKCgoqGZ8y2kdHRxfNKgOkDv1rsoGMjAw1ZMhg1bDhi6pZs6Zqzpw50n758uXS9ujRo1IvJSVFjR49Ssbg+j/66EP15EnxFvr/kgDbt5yy1C6Lp/mFRsU6Ko4SYNw4P/Xw4UORnJwcacMNRQmdO3eSmSA1NVXqopyWLVuojh07SLpFi+ZCEM4s9O3bR/KnTp2qvL29pXzbtq0y1qFDByXdqFFD1alTR9W8eTNJT5gwXsZDcazz9evXkzX8nXe6CwEAhKNuTMwBSbMkcA2jRo0UMlE2Zszokn5Iuw0BuChHxARTvapKZdAE4Gls0qSxyNtvvyXKrIgApHNzcyUPJZB39+5d6Y82lD1+/FgtWLBAyvz9/aVME+DHH2cLYZKTkyXNLMB1rlixQtIBAQEyPqKv35YAtIeo2CnMCpCybVtvaeN2BHBnaAJ06/a2WrZsmci6devkxldEgH79+klb6rzySlvJu337tqTPnz8vTy9POULZ5MmTpL4mwMGDMZK+c+eOpFEcbX/4IUjSV69ekXJr2BKAmWrkyK/k+vQ4L7/cxj0JwI9zREww1auqVIbKbICqEiArK0vqY62fPn1aHT58WMocJcDs2bMlvXv3bim3hjUBqNujxzuSxv7AHmDmsiXA+PHjLK1dByMBJoZfMK7P1pKeVf7AJ7ifmWO0GRyVTl4BlZKgJgmAMcf3Pn36CBlmzZolaUcJsHfvHln/u3TpLMvDjRs31JUrl6WuLQGo9+KLDeSa6I/vmgDMDqRff/01MWRdCacJkJmTZ6ldFpn3so2KdVRcSQDWZG0T8ERi5DE9O0oAxmAHQB5rOkqkf9Z7WwL07t1L0uwC9G5EEwAbpNQA3SZjuQo1ToDUlEyjYh0VewR49OiRrNtpaWmWnFJwMy9evKguX74sfbAPp25SUpKlhlKXLl2SPO2mZRu3dOkStWvXLiEQ5RAHQBDq8glQOGnq6GtkzISEBLV48WIVFRUlfQDIYt0WJWOrrF0bLgYoM4Z1P9euXVOLFi1ScXEnJe0qOE0AIn4mXE/KMCrWUbFHAA9qFk4TILeg7Ll/jU1Rx42KdVQ8BHAtnCIAsf6KlISH0KRYR8VDANfCKQIMX3amQiXxSphJsY6KowSgDtsnLHks+OqSBuPr448/UqdOmT2czoB9PX1iFLornCLA1HWlxos18vMLVWfvQKNiHRVHCIDiCftiNWsZPPh98eY5i4ULF0o/e/bsseRUH2wP6RPj0V3hFAG2xZcGQ6xx9062avrCeKNiHRV7BMDKfuMNH7mxkAAfO/tn0u+/P0iscmfgIYAV7BHg7C3zK9wcETMptSpijwCbN2+Wm/rpp0NLlM0W67XXukj+mTMJkhcaulAIcfDgQQnSsD9fvHiRunfvnhwY8fb2UsOGfSq+eaAJEBgYWLS3HyLlRO/oGxw/flz6CQ8PlzRKJf3ll19IGuDh8/XtLwEi/BStWrUsIQC/iWvx8fFRXl5e6r33fGW5IX/SpG8kKHX27BkJc3OtCxaEyEw3dOhQuRY+9bVyTWxd33rrTemLtoytgd/Dz89PtrY8LEQlQ0JCjPe1ygTgTZ9HueUZTed9ugUblVoVqYwA5A8YUBxJO3my7H45JKTY8bJq1UpJo0gdMGKGwBNHOW5fnkztj9+3b6/U1wRACA9z0/g+ZswYGXf//v2SxsED8COQRgmg2JnjJXmvvtq+ZFZCIADE41oYf+7cn4SwYWFh0vegQQOlHg4i3Y7rpT+ikDqEvH79OhkrPv6U5BHDgICU4UjSMw3OMBxTjEd7+iJtTRKNKhNg+qZiJ4st0m4/kLeETEqtitgjAMrhB+PJswYOFPK/+GK4pCEA6d9/PyozxXfffSvpadOmilG2b98+SesAjCbA3LnFJ50zMzPlBnKjubH2CBATEyNpQr08qbTBY0ge3zkZxHee/Ozs7KK8fLkuawJARvKIPpLmiBhtd+zYIWk929AG45cyPglnQ3acWgACUP/q1avS36hRoyQdF1f+EG+VCNC3SOKulz8IygWNG7nSqNCqij0C4Lfnx+A5s0ZU1HrJ5/AH0AS4d6847Ltx40ZJ89SBc+fOSdrPb6ykTTYATw95eAbtEWD27GBJM+1qWNsACDsC0pCK5QWvpiYAT6n2bu7YES31Tpw4LunExERJa3Iz23C9HTq8WhJj4FM/FJoAeokMCPCXtO2sCapEgLGrzxV1Wl45N5LvquYNJhoVWlWxZwMEBRUHbJjyNag/dOgnkh8bGyt51SUAN08/wdnZD0sIQAQQ2BKAp5U0J4E0bI1A+iTiSCibfHYuzEZVJUBoaKikuXaUzgmoWifAkIXx6m52ef//kyd5yqfDf4zKdEbsEQAfOlMzazhKxeceHPyDTIGs23or6CwBpkyZIlP0zp07pU8OmXIjuXmU9+7dW2INM2fOlLQmwIkTJyTNU3n//n1J67UbArAssIYTG2Cqpgxjj7KqEIB7M2DAe3JtkJW+9ExQawTgkKfpz5uYDQImRxoV6azYIwBlnNHDqOFHaSG6xhk+DWcJ0KZN6xLF8Un0EaA4L6+XJR/hppPWBOBm850ypmRERxpRcmRkhCiJ42jsDvjO+UPaVXUGWLZsqaS5B1wj49QaAfD6XU0vXqusgfJnBm40KrE6Yo8AgHJu1urVq2VKjoiIkPXUGsTm+cE66ocVTpoZAzBTkE5KKrYl6A8jiX7wCnK279atW2WuhaeN/IiItdKeyCNE0iCWHx4eJnYI42OnMAZ9IEQl2QFwzRcuXBAFkZ+YeEmMWL3NYwahnY4k4vsgjVEHWDZ4COiHiCK/zbo920s9LtD3QvdnjQoJgMH3857r6nFeeTdmfn6BmjJxrVGB1RVHCOBBzcFIgDnRSTLl2ypCWHw1Q/V6Y5ZReTUhHgK4FkYCmBSAsbfk573yN3AmxdWUuCMBuJ6/KimNBLAG69SGdceqHeRxVBwlAIYVzhos9tpUDuvq8OHDxZDSRtVfCZUS4Epimlq1NEbF7DuvkpPuqPTbD1R6WpZ83x2dIDsAFGZSpLNijwCUYbFj9bMVwtpma6a9YDUNjEJ8+/3793PrsK6zsDsD2ANvCG/ZdFJ1afutUaFVFXsEOHv2rCie7VRwcLAcymQrdOjQIUuNmgXXghWudxN/NVSbABp5eQUqZM6OWg8H6/080TbqITz9ug2fnOZlb43HjVex8OQBomtE+vCtR0ZGShRt0aJf1AcfDCnzUgbbMOoRUWRr9/nnn6mxY8eUzAAsC99//72Eo3v06CHbPsZlicATyAlgIoUQVHsB3RU1RgDATYg9nKhaNfzGqFxHxB4BDhw4IARgBli5cmXR3rasDYDjhmWBqBuOE5aKbt26ifL0sW4cODhRcOawHycCxyyCPQG2bNki9Y4cOSL7fRwtBFxQJjMBnjjKiRXg/Bkx4ktR/vTp0yUf4hGKxjnDclXZ73neqFECaCRfv6PatZhiVLA9sUcAFIn3jpuriTB58mQJkKAEQqSc78fpQj+QBEKgfE0A0ngN6UvXIR9nCfD19ZU6KN+WALGxR6QucX9mAvogH/LQhvg7aa4Fu4HQsJ453BG1QgBwJ+Oher3dd0YlVyb2CAAoJybAtE1cAIVwQASF4F9HEQRy+K7dscTCNQG6d+9eZgxcqMQWsPQhErMDr29Tx5YAmzYVL0G8FWQNCEc+MwnjInwnxl8nCQAgQbcuM42KrkjsEYAyfUP5zlPLjefwBNMzASFmhTVr1qjt27eXCGu5JgDv6VmPwdPKes6UrmPvOqxrS4DffvtNyvXBEw3creSznPB6uR6X9wYr+z3PG7VKAPDkcZ4a+fkyo7JN4ogRyDQbHx8v79ShaG48UTvaYfQxA3B0C6KgeE4Ng4oIAAiwsLtgTSeYomMLtgRISDgtyw9EI1bA1M//ADH7sPRAvps3b8rYjEu+O6PWCQAKC4us40X7VbP6E4xKt5bKCEC+v/80URSK1MI0q88ComQMQPLZv6MQ3ufnKa+MAOwkdH+ffTaspNyWAPTz1VcjpJ6OxhFBhAhsRVlKICAGJt852+fOcAkBADc05WamGtxvXqVbRUeWANbzFSuWyx85hIWtEcVat2Fm4PAo5UuWLFapqSlSztOIkoj62Y5Bmj9uoPzmzRuW3GKjk3wOheo25LHbCAwMULNm/VdsCMoQxmKLyNj8dxE2hTvDZQTQ4CbhScRn0NNnlvJu9u8S5XOmsNebQZaaHrgCLieANZhO8/MKip6S/BIx/fO4B7WH50oAD54/PASo4/AQoI7DQ4A6DaX+B1rP/1wmoFU5AAAAAElFTkSuQmCC"
                              alt=""
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div
                      className="text_one color_one"
                      style={{
                        clear: "both",
                        marginTop: "30px",
                        marginBottom: "2px",
                      }}
                    >
                      Complaint form
                    </div>
                    <p
                      className="color_one f-wb text_thre"
                      style={{ marginBottom: "10px" }}
                    >
                      Please use this form to tell us about your complaint – so
                      we can help resolve it. If you’re not sure about anything,
                      or have difficulties filling in this form, just phone us
                      on 0800 023 4567. Please note all calls with our casework
                      teams are recorded.
                    </p>
                    <p style={{ fontSize: "14px" }}>
                      If you have agreed to make this complaint on behalf of
                      someone else, you will need to ask them to check
                      everything is correct and sign and date this form in the
                      declaration section.
                    </p>
                    <h3
                      className="text_two color_one"
                      style={{ marginBottom: 0 }}
                    >
                      Your details
                    </h3>
                    <p className="f-wb" style={{ marginBottom: "10px" }}>
                      Your details (the person complaining
                    </p>
                    <div className="table_resp">
                      <table className="table border">
                        <tbody>
                          <tr>
                            <td style={{ width: "120px" }}>Title</td>
                            <td colSpan={12} style={{ width: "100px" }}>
                              {salutation}
                            </td>
                            <td>First name</td>
                            <td colSpan={8}>{fName} &nbsp;</td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                height: "30px",
                                borderBottom: "1px solid #fff",
                              }}
                            >
                              Surname
                            </td>
                            <td colSpan={12}>{lName}</td>
                            <td>Date of birth</td>
                            {dobDateArr && dobDateArr.length > 0 && (
                              <DobDateStr />
                            )}
                            {dobMonthArr && dobMonthArr.length > 0 && (
                              <DobMonthStr />
                            )}
                            {dobYearArr && dobYearArr.length > 0 && (
                              <DobYearStr />
                            )}
                          </tr>

                          <tr>
                            <td style={{ borderBottom: "1px solid #fff" }}>
                              Address for <br />
                              writing to you
                            </td>
                            <td
                              colSpan={21}
                              style={{ borderBottom: "1px solid #fff" }}
                            >
                              {address}
                            </td>
                          </tr>

                          <tr>
                            <td style={{ borderBottom: "1px solid #fff" }}>
                              Address line 1
                            </td>
                            <td
                              colSpan={21}
                              style={{ borderBottom: "1px solid #fff" }}
                            >
                              {addressLine1}
                            </td>
                          </tr>

                          <tr>
                            <td style={{ borderBottom: "1px solid #fff" }}>
                              Address line 2
                            </td>
                            <td
                              colSpan={21}
                              style={{ borderBottom: "1px solid #fff" }}
                            >
                              {addressLine2}
                            </td>
                          </tr>

                          <tr>
                            <td style={{}}>Address line 3</td>
                            <td colSpan={21}>{addressLine3}</td>
                          </tr>

                          <tr>
                            <td style={{ borderBottom: "1px solid #fff" }}>
                              City
                            </td>
                            <td colSpan={12} style={{}}>
                              {city}
                            </td>
                            <td style={{ borderBottom: "1px solid #fff" }}>
                              County
                            </td>
                            <td colSpan={8}>{county}</td>
                          </tr>

                          <tr>
                            <td style={{ borderBottom: "1px solid #fff" }}>
                              Postcode
                            </td>

                            {postcodeArr && postcodeArr.length > 0 && (
                              <PostcodeStr />
                            )}

                            <td style={{ borderBottom: "1px solid #fff" }}>
                              Country
                            </td>
                            <td colSpan={8}>{country}</td>
                          </tr>

                          <tr>
                            <td>Phone number 1</td>
                            {phoneArr && phoneArr.length > 0 && <PhoneStr />}

                            <td>Phone number 2</td>
                            <td colSpan={8} />
                          </tr>

                          <tr>
                            <td>Email</td>
                            <td colSpan={21}>{email}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* End Table  */}
                    <h3>
                      Details of anyone complaining with you (for example, a
                      joint policy/account holder)
                    </h3>

                    <div className="table_resp">
                      <table className="table border">
                        <tbody>
                          <tr>
                            <td
                              style={{
                                width: "120px",
                                borderBottom: "1px solid #fff",
                              }}
                            >
                              Title
                            </td>
                            <td colSpan={12} style={{ width: "100px" }} />
                            <td>First name</td>
                            <td colSpan={8} />
                          </tr>
                          <tr>
                            <td style={{ height: "30px" }}>Surname</td>
                            <td colSpan={12} />
                            <td>Date of birth</td>
                            <td
                              style={{
                                verticalAlign: "bottom",
                                textAlign: "center",
                              }}
                            >
                              D
                            </td>
                            <td
                              style={{
                                verticalAlign: "bottom",
                                textAlign: "center",
                              }}
                            >
                              D
                            </td>
                            <td
                              style={{
                                verticalAlign: "bottom",
                                textAlign: "center",
                              }}
                            >
                              M
                            </td>
                            <td
                              style={{
                                verticalAlign: "bottom",
                                textAlign: "center",
                              }}
                            >
                              M
                            </td>
                            <td
                              style={{
                                verticalAlign: "bottom",
                                textAlign: "center",
                              }}
                            >
                              Y
                            </td>
                            <td
                              style={{
                                verticalAlign: "bottom",
                                textAlign: "center",
                              }}
                            >
                              Y
                            </td>
                            <td
                              style={{
                                verticalAlign: "bottom",
                                textAlign: "center",
                              }}
                            >
                              Y
                            </td>
                            <td
                              style={{
                                verticalAlign: "bottom",
                                textAlign: "center",
                              }}
                            >
                              Y
                            </td>
                          </tr>
                          <tr>
                            <td style={{ borderBottom: "1px solid #fff" }}>
                              Address for <br />
                              writing to you
                            </td>
                            <td
                              colSpan={21}
                              style={{ borderBottom: "1px solid #fff" }}
                            />
                          </tr>
                          <tr>
                            <td style={{ borderBottom: "1px solid #fff" }}>
                              Address line 1
                            </td>
                            <td
                              colSpan={21}
                              style={{ borderBottom: "1px solid #fff" }}
                            />
                          </tr>
                          <tr>
                            <td style={{ borderBottom: "1px solid #fff" }}>
                              Address line 2
                            </td>
                            <td
                              colSpan={21}
                              style={{ borderBottom: "1px solid #fff" }}
                            />
                          </tr>
                          <tr>
                            <td style={{ borderBottom: "1px solid #fff" }}>
                              Address line 3 <br />
                              <br />
                            </td>
                            <td colSpan={21} />
                          </tr>
                          <tr>
                            <td style={{}}>City</td>
                            <td colSpan={12} style={{}} />
                            <td style={{ borderBottom: "1px solid #fff" }}>
                              County
                            </td>
                            <td colSpan={8} />
                          </tr>
                          <tr>
                            <td style={{ borderBottom: "1px solid #fff" }}>
                              Postcode
                            </td>
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td style={{ borderBottom: "1px solid #fff" }}>
                              Country
                            </td>
                            <td colSpan={8} />
                          </tr>
                          <tr>
                            <td style={{ borderBottom: "1px solid #fff" }}>
                              Phone number 1
                            </td>
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td>Phone number 2</td>
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                          </tr>
                          <tr>
                            <td>Email</td>
                            <td colSpan={21} />
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* End Table  */}
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <div
                              className="sml_text"
                              style={{ verticalAlign: "center" }}
                            >
                              Financial Ombudsman Service – Complaint form
                            </div>
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              verticalAlign: "center",
                            }}
                          >
                            1
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <div className="page-break" />
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <table className="adition_page">
              <tbody>
                <tr>
                  <td>
                    <table className="log_hd">
                      <tbody>
                        <tr>
                          <td
                            style={{
                              textAlign: "right",
                              verticalAlign: "bottom",
                              fontSize: "12px",
                              paddingBottom: "5px",
                            }}
                          />
                          <td />
                          <td style={{ textAlign: "right" }}>
                            <img
                              src="data:image/png;base64,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"
                              alt=""
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div className="table_resp">
                      <table className="table border" style={{ clear: "both" }}>
                        <tbody>
                          <tr>
                            <td style={{ verticalAlign: "middle" }}>
                              How would you like us to contact you?
                            </td>
                            <td style={{ borderRight: "1px solid #fff" }}>
                              <img
                                style={{ marginTop: "15px" }}
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAdCAYAAABSZrcyAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALjSURBVEhLxZY/SHJhFIe/vSEKQw0Cg+gfRCFBQxBEQ1MQhIZDOTjU0NSSWEiFRVtRREQQpBAJNdjaoEmDBIEQBQpBTUYFQWVQkb+PczqfdfOa11S+Z3t/Xu/z3nvf97znD/4jmuUvLy84Pj7G2toaXC4XJiYmMDMzg93dXVxdXclV+ZFTfnp6ipGREZSXl6O1tRUOhwMejwcLCwuYmppCX18fDAYDmpubsbq6isfHR/lnbrLK6SYkNRqNmJ2dxfX1tfyiTjAYxMDAAKqrqxEIBCT9GVX5+fk5amtr+SkfHh4k1cbR0RHq6up44u/v75KqkyEnMc3e6/VKkj9PT0/o6enB0NDQjxNQyO/v71FTUwOfzyfJ73l+fkZ3dzecTqckmSjkNNOxsTEZFc7NzQ0vxkgkIomStJy+FX3nZDIpSXHw+/0wm80yUpKWW61WLC8vy6h4pFIp1NfX88N9h+W3t7eoqKjIe2VrZWlpiT/pd1i+v7+P3t5eDkpBLBaDyWSS0Scsd7vdmJyc5KAU0KunCnl3dyfJByynV1LIvtZCe3s7nw1fYfng4CB2dnY4KBWdnZ0Zi47ldrsdm5ubHJSKtrY2nJycyOgDls/Pz2N8fJyDUvD29oaysrKM3cTyg4MDdHV1cVAKotEompqaZPQJy2lGtM8TiQSHxYZ2k1rZZjkxOjqK6elpGRWP19dX7gnOzs4k+SQtp6NUr9fnbBryZXFxMWsBS8sJ6s36+/tlVDhU2XQ6HS4uLiRRopBTk0gnUDGqHa2fhoYGrK+vS5KJQk7QIdPS0sJNQK42KBuXl5dobGzE3NycJOpkyAmaAHUhVJXi8bik2tjY2EBVVZWm41lVTtBhsLKygsrKSlgsFoRCIS4WatCBQdfSXu7o6FBd2Wpklf+DagDdmMojVSm6uc1mw/DwMC9O6n7oxKJm5PDwUP6ljZzyr1BXGg6Hsb29ja2tLezt7fGKprf0G/KSFxfgL6JcFKOHO80gAAAAAElFTkSuQmCC"
                                alt=""
                              />
                              Phone
                            </td>
                            <td style={{ borderRight: "1px solid #fff" }}>
                              <img
                                style={{ marginTop: "15px" }}
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAgCAYAAADqgqNBAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAQVSURBVFhH7ZZLSGNXGMdzLbZTJ7FgfWFVWkWlalUcatqMtosiCAoVXwiOgqgLF9VakCx04qtjxQcVF25EQSzoqIuiWFe1FoYG0zDJVKUoUiRO8TV1QnVMgo9/c06+iTeaxBtbmE1/EJLvuzf53XPyne8cGV4h/8slcXJyAoPBgKGhITQ3N0OtVqOlpQUTExPY2Nigu6QjSc5+uKGhAUFBQUhMTERFRQU6OjrQ1dUFjUaDgoICREVFISYmBj09PTg4OKBveser3Gq18tGFhITw983NTbrinqWlJZSXl/P7R0dHKesZj3KTyYTk5GQUFhZib2+PstIwGo1ISUlBUVERH4An3MqZODY2Fr29vZTxHZvNhpKSEuTm5np8gCtydmNSUhL6+vooc3NYgbLRV1ZWUsaVK/LGxkYUFxdTdEOsf8G0bcaZ/ePR0REvxNnZWcc1ES7ytbU1hIaGYn9/nzK+8eL3h1B/noaIdz5F+y9mygKLi4uIjo7G6ekpZRy4yOvq6tDU1ESRb5w9fYh77/pD8H8PFdN/8lGLyczMxPT0NEUOnHJWIGwdb21tUcYHbCv49rO34SfcwgdfLeA5pcWwRpSdnU2RA6dcp9MhNTWVIl+wwth5FwpBwO0PNdBZKH0Js9kMhUKBs7OLOXHKBwcHUVVVRZF0rIYHUCkECHIl2vUezERcXBxWVlYoEslZlXd3d1MkEasBX3+sgCAooHpgsM+Bd/Ly8jAzM0ORSF5fX4/+/n6KpGDF4/aPIBf8EJjVhd9slPYC65bionPKWe/u7OykyA0WE7Tf/4Anzx3/meXXNihvC/AL/ATdyxLMdnJycjA3N0eRSD4yMoKysjKKLmF9hPvpgfZq9kdqsx62F1rcvxPAp/vuN08gTQ1ERka6bL1O+fLyMhISEii6hGUWlWF+kMlkeC0yH1/eex+3WHUr2/H4uj+a2NnZ4UtZjFPOlkBERARWV1cpI+YZRvPfgmCXswdgL+HNO9Asea9uMWw1sT4vxilntLa2ora2liJXnn1XiCA/kgtvIEX9CEd0TQpss1pYWKDIgYt8e3sbwcHBWF9fp4yIowV8EWdvnzIBryc2YPFvyktgfHwcaWlpFF3gImcMDAxApVK5dKKXHP6hw08//gzjU+nTzQYUFhYGvV5PmQuuyM/Pz3kPrqmp4Z//DaylZmRkoK2tjTKuXJEzDg8PkZWVherqar7h3ITd3V0uZs3LE27lDPYA+fn5/CzGjsu+MDU1hfDwcH6s9oZH+UvGxsb4AYOdxebn5z2ex9gUs0aVnp7OK5udZK/jWjnj+PgYw8PDUCqVCAgI4ILS0lJ+fmf9Oj4+HnK5nG8c7AGl1ookuRiLxQKtVsuXDzubT05O8m3S3eq4Dp/l/yWvUA78A6yDDm3QxQl2AAAAAElFTkSuQmCC"
                                alt=""
                              />
                              Email
                            </td>
                            <td>
                              <img
                                style={{ marginTop: "15px" }}
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAdCAYAAABSZrcyAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALjSURBVEhLxZY/SHJhFIe/vSEKQw0Cg+gfRCFBQxBEQ1MQhIZDOTjU0NSSWEiFRVtRREQQpBAJNdjaoEmDBIEQBQpBTUYFQWVQkb+PczqfdfOa11S+Z3t/Xu/z3nvf97znD/4jmuUvLy84Pj7G2toaXC4XJiYmMDMzg93dXVxdXclV+ZFTfnp6ipGREZSXl6O1tRUOhwMejwcLCwuYmppCX18fDAYDmpubsbq6isfHR/lnbrLK6SYkNRqNmJ2dxfX1tfyiTjAYxMDAAKqrqxEIBCT9GVX5+fk5amtr+SkfHh4k1cbR0RHq6up44u/v75KqkyEnMc3e6/VKkj9PT0/o6enB0NDQjxNQyO/v71FTUwOfzyfJ73l+fkZ3dzecTqckmSjkNNOxsTEZFc7NzQ0vxkgkIomStJy+FX3nZDIpSXHw+/0wm80yUpKWW61WLC8vy6h4pFIp1NfX88N9h+W3t7eoqKjIe2VrZWlpiT/pd1i+v7+P3t5eDkpBLBaDyWSS0Scsd7vdmJyc5KAU0KunCnl3dyfJByynV1LIvtZCe3s7nw1fYfng4CB2dnY4KBWdnZ0Zi47ldrsdm5ubHJSKtrY2nJycyOgDls/Pz2N8fJyDUvD29oaysrKM3cTyg4MDdHV1cVAKotEompqaZPQJy2lGtM8TiQSHxYZ2k1rZZjkxOjqK6elpGRWP19dX7gnOzs4k+SQtp6NUr9fnbBryZXFxMWsBS8sJ6s36+/tlVDhU2XQ6HS4uLiRRopBTk0gnUDGqHa2fhoYGrK+vS5KJQk7QIdPS0sJNQK42KBuXl5dobGzE3NycJOpkyAmaAHUhVJXi8bik2tjY2EBVVZWm41lVTtBhsLKygsrKSlgsFoRCIS4WatCBQdfSXu7o6FBd2Wpklf+DagDdmMojVSm6uc1mw/DwMC9O6n7oxKJm5PDwUP6ljZzyr1BXGg6Hsb29ja2tLezt7fGKprf0G/KSFxfgL6JcFKOHO80gAAAAAElFTkSuQmCC"
                                alt=""
                              />
                              Phone
                            </td>
                          </tr>
                          <tr>
                            <td style={{ verticalAlign: "middle" }}>
                              There will be times when we need to write to you –
                              for <br />
                              example, to send you the outcome of your
                              complaint. <br />
                              When we do, would you prefer an email or letter?
                            </td>
                            <td style={{ borderRight: "1px solid #fff" }}>
                              <img
                                style={{ marginTop: "15px" }}
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAgCAYAAADqgqNBAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAQVSURBVFhH7ZZLSGNXGMdzLbZTJ7FgfWFVWkWlalUcatqMtosiCAoVXwiOgqgLF9VakCx04qtjxQcVF25EQSzoqIuiWFe1FoYG0zDJVKUoUiRO8TV1QnVMgo9/c06+iTeaxBtbmE1/EJLvuzf53XPyne8cGV4h/8slcXJyAoPBgKGhITQ3N0OtVqOlpQUTExPY2Nigu6QjSc5+uKGhAUFBQUhMTERFRQU6OjrQ1dUFjUaDgoICREVFISYmBj09PTg4OKBveser3Gq18tGFhITw983NTbrinqWlJZSXl/P7R0dHKesZj3KTyYTk5GQUFhZib2+PstIwGo1ISUlBUVERH4An3MqZODY2Fr29vZTxHZvNhpKSEuTm5np8gCtydmNSUhL6+vooc3NYgbLRV1ZWUsaVK/LGxkYUFxdTdEOsf8G0bcaZ/ePR0REvxNnZWcc1ES7ytbU1hIaGYn9/nzK+8eL3h1B/noaIdz5F+y9mygKLi4uIjo7G6ekpZRy4yOvq6tDU1ESRb5w9fYh77/pD8H8PFdN/8lGLyczMxPT0NEUOnHJWIGwdb21tUcYHbCv49rO34SfcwgdfLeA5pcWwRpSdnU2RA6dcp9MhNTWVIl+wwth5FwpBwO0PNdBZKH0Js9kMhUKBs7OLOXHKBwcHUVVVRZF0rIYHUCkECHIl2vUezERcXBxWVlYoEslZlXd3d1MkEasBX3+sgCAooHpgsM+Bd/Ly8jAzM0ORSF5fX4/+/n6KpGDF4/aPIBf8EJjVhd9slPYC65bionPKWe/u7OykyA0WE7Tf/4Anzx3/meXXNihvC/AL/ATdyxLMdnJycjA3N0eRSD4yMoKysjKKLmF9hPvpgfZq9kdqsx62F1rcvxPAp/vuN08gTQ1ERka6bL1O+fLyMhISEii6hGUWlWF+kMlkeC0yH1/eex+3WHUr2/H4uj+a2NnZ4UtZjFPOlkBERARWV1cpI+YZRvPfgmCXswdgL+HNO9Asea9uMWw1sT4vxilntLa2ora2liJXnn1XiCA/kgtvIEX9CEd0TQpss1pYWKDIgYt8e3sbwcHBWF9fp4yIowV8EWdvnzIBryc2YPFvyktgfHwcaWlpFF3gImcMDAxApVK5dKKXHP6hw08//gzjU+nTzQYUFhYGvV5PmQuuyM/Pz3kPrqmp4Z//DaylZmRkoK2tjTKuXJEzDg8PkZWVherqar7h3ITd3V0uZs3LE27lDPYA+fn5/CzGjsu+MDU1hfDwcH6s9oZH+UvGxsb4AYOdxebn5z2ex9gUs0aVnp7OK5udZK/jWjnj+PgYw8PDUCqVCAgI4ILS0lJ+fmf9Oj4+HnK5nG8c7AGl1ookuRiLxQKtVsuXDzubT05O8m3S3eq4Dp/l/yWvUA78A6yDDm3QxQl2AAAAAElFTkSuQmCC"
                                alt=""
                              />
                              Email
                            </td>
                            <td colSpan={2}>
                              <img
                                style={{ marginTop: "15px" }}
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAdCAYAAABSZrcyAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALjSURBVEhLxZY/SHJhFIe/vSEKQw0Cg+gfRCFBQxBEQ1MQhIZDOTjU0NSSWEiFRVtRREQQpBAJNdjaoEmDBIEQBQpBTUYFQWVQkb+PczqfdfOa11S+Z3t/Xu/z3nvf97znD/4jmuUvLy84Pj7G2toaXC4XJiYmMDMzg93dXVxdXclV+ZFTfnp6ipGREZSXl6O1tRUOhwMejwcLCwuYmppCX18fDAYDmpubsbq6isfHR/lnbrLK6SYkNRqNmJ2dxfX1tfyiTjAYxMDAAKqrqxEIBCT9GVX5+fk5amtr+SkfHh4k1cbR0RHq6up44u/v75KqkyEnMc3e6/VKkj9PT0/o6enB0NDQjxNQyO/v71FTUwOfzyfJ73l+fkZ3dzecTqckmSjkNNOxsTEZFc7NzQ0vxkgkIomStJy+FX3nZDIpSXHw+/0wm80yUpKWW61WLC8vy6h4pFIp1NfX88N9h+W3t7eoqKjIe2VrZWlpiT/pd1i+v7+P3t5eDkpBLBaDyWSS0Scsd7vdmJyc5KAU0KunCnl3dyfJByynV1LIvtZCe3s7nw1fYfng4CB2dnY4KBWdnZ0Zi47ldrsdm5ubHJSKtrY2nJycyOgDls/Pz2N8fJyDUvD29oaysrKM3cTyg4MDdHV1cVAKotEompqaZPQJy2lGtM8TiQSHxYZ2k1rZZjkxOjqK6elpGRWP19dX7gnOzs4k+SQtp6NUr9fnbBryZXFxMWsBS8sJ6s36+/tlVDhU2XQ6HS4uLiRRopBTk0gnUDGqHa2fhoYGrK+vS5KJQk7QIdPS0sJNQK42KBuXl5dobGzE3NycJOpkyAmaAHUhVJXi8bik2tjY2EBVVZWm41lVTtBhsLKygsrKSlgsFoRCIS4WatCBQdfSXu7o6FBd2Wpklf+DagDdmMojVSm6uc1mw/DwMC9O6n7oxKJm5PDwUP6ljZzyr1BXGg6Hsb29ja2tLezt7fGKprf0G/KSFxfgL6JcFKOHO80gAAAAAElFTkSuQmCC"
                                alt=""
                              />
                              Post
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                verticalAlign: "middle",
                                borderBottom: "1px solid #fff",
                              }}
                            >
                              Have you used our service before? <br />
                              (This is so we can link our records)
                            </td>
                            <td
                              style={{
                                borderRight: "1px solid #fff",
                                borderBottom: "1px solid #fff",
                              }}
                            >
                              <img
                                style={{ marginTop: "15px" }}
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAdCAYAAABSZrcyAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALjSURBVEhLxZY/SHJhFIe/vSEKQw0Cg+gfRCFBQxBEQ1MQhIZDOTjU0NSSWEiFRVtRREQQpBAJNdjaoEmDBIEQBQpBTUYFQWVQkb+PczqfdfOa11S+Z3t/Xu/z3nvf97znD/4jmuUvLy84Pj7G2toaXC4XJiYmMDMzg93dXVxdXclV+ZFTfnp6ipGREZSXl6O1tRUOhwMejwcLCwuYmppCX18fDAYDmpubsbq6isfHR/lnbrLK6SYkNRqNmJ2dxfX1tfyiTjAYxMDAAKqrqxEIBCT9GVX5+fk5amtr+SkfHh4k1cbR0RHq6up44u/v75KqkyEnMc3e6/VKkj9PT0/o6enB0NDQjxNQyO/v71FTUwOfzyfJ73l+fkZ3dzecTqckmSjkNNOxsTEZFc7NzQ0vxkgkIomStJy+FX3nZDIpSXHw+/0wm80yUpKWW61WLC8vy6h4pFIp1NfX88N9h+W3t7eoqKjIe2VrZWlpiT/pd1i+v7+P3t5eDkpBLBaDyWSS0Scsd7vdmJyc5KAU0KunCnl3dyfJByynV1LIvtZCe3s7nw1fYfng4CB2dnY4KBWdnZ0Zi47ldrsdm5ubHJSKtrY2nJycyOgDls/Pz2N8fJyDUvD29oaysrKM3cTyg4MDdHV1cVAKotEompqaZPQJy2lGtM8TiQSHxYZ2k1rZZjkxOjqK6elpGRWP19dX7gnOzs4k+SQtp6NUr9fnbBryZXFxMWsBS8sJ6s36+/tlVDhU2XQ6HS4uLiRRopBTk0gnUDGqHa2fhoYGrK+vS5KJQk7QIdPS0sJNQK42KBuXl5dobGzE3NycJOpkyAmaAHUhVJXi8bik2tjY2EBVVZWm41lVTtBhsLKygsrKSlgsFoRCIS4WatCBQdfSXu7o6FBd2Wpklf+DagDdmMojVSm6uc1mw/DwMC9O6n7oxKJm5PDwUP6ljZzyr1BXGg6Hsb29ja2tLezt7fGKprf0G/KSFxfgL6JcFKOHO80gAAAAAElFTkSuQmCC"
                                alt=""
                              />
                              Yes
                            </td>
                            <td
                              colSpan={2}
                              style={{ borderBottom: "1px solid #fff" }}
                            >
                              <img
                                style={{ marginTop: "15px" }}
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAgCAYAAADqgqNBAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAQVSURBVFhH7ZZLSGNXGMdzLbZTJ7FgfWFVWkWlalUcatqMtosiCAoVXwiOgqgLF9VakCx04qtjxQcVF25EQSzoqIuiWFe1FoYG0zDJVKUoUiRO8TV1QnVMgo9/c06+iTeaxBtbmE1/EJLvuzf53XPyne8cGV4h/8slcXJyAoPBgKGhITQ3N0OtVqOlpQUTExPY2Nigu6QjSc5+uKGhAUFBQUhMTERFRQU6OjrQ1dUFjUaDgoICREVFISYmBj09PTg4OKBveser3Gq18tGFhITw983NTbrinqWlJZSXl/P7R0dHKesZj3KTyYTk5GQUFhZib2+PstIwGo1ISUlBUVERH4An3MqZODY2Fr29vZTxHZvNhpKSEuTm5np8gCtydmNSUhL6+vooc3NYgbLRV1ZWUsaVK/LGxkYUFxdTdEOsf8G0bcaZ/ePR0REvxNnZWcc1ES7ytbU1hIaGYn9/nzK+8eL3h1B/noaIdz5F+y9mygKLi4uIjo7G6ekpZRy4yOvq6tDU1ESRb5w9fYh77/pD8H8PFdN/8lGLyczMxPT0NEUOnHJWIGwdb21tUcYHbCv49rO34SfcwgdfLeA5pcWwRpSdnU2RA6dcp9MhNTWVIl+wwth5FwpBwO0PNdBZKH0Js9kMhUKBs7OLOXHKBwcHUVVVRZF0rIYHUCkECHIl2vUezERcXBxWVlYoEslZlXd3d1MkEasBX3+sgCAooHpgsM+Bd/Ly8jAzM0ORSF5fX4/+/n6KpGDF4/aPIBf8EJjVhd9slPYC65bionPKWe/u7OykyA0WE7Tf/4Anzx3/meXXNihvC/AL/ATdyxLMdnJycjA3N0eRSD4yMoKysjKKLmF9hPvpgfZq9kdqsx62F1rcvxPAp/vuN08gTQ1ERka6bL1O+fLyMhISEii6hGUWlWF+kMlkeC0yH1/eex+3WHUr2/H4uj+a2NnZ4UtZjFPOlkBERARWV1cpI+YZRvPfgmCXswdgL+HNO9Asea9uMWw1sT4vxilntLa2ora2liJXnn1XiCA/kgtvIEX9CEd0TQpss1pYWKDIgYt8e3sbwcHBWF9fp4yIowV8EWdvnzIBryc2YPFvyktgfHwcaWlpFF3gImcMDAxApVK5dKKXHP6hw08//gzjU+nTzQYUFhYGvV5PmQuuyM/Pz3kPrqmp4Z//DaylZmRkoK2tjTKuXJEzDg8PkZWVherqar7h3ITd3V0uZs3LE27lDPYA+fn5/CzGjsu+MDU1hfDwcH6s9oZH+UvGxsb4AYOdxebn5z2ex9gUs0aVnp7OK5udZK/jWjnj+PgYw8PDUCqVCAgI4ILS0lJ+fmf9Oj4+HnK5nG8c7AGl1ookuRiLxQKtVsuXDzubT05O8m3S3eq4Dp/l/yWvUA78A6yDDm3QxQl2AAAAAElFTkSuQmCC"
                                alt=""
                              />
                              No
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={4}>
                              Do you have any practical needs where we could
                              help by making adjustments – like using large
                              print, Braille or a different language?
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={4}>
                              <div
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                No <br />
                                <br />
                                <br />
                                <br />
                                <br />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* End */}
                    <div
                      className="color_one f-wb text_thre"
                      style={{ marginTop: "20px" }}
                    >
                      If the complaint relates to a business account or you are
                      a small business, charity or trust you need to fill out
                      the following sections. Please make sure that you list the
                      names of all directors/partners/trustees authorised. The
                      person completing the form should be the director, partner
                      or trustee.
                    </div>
                    <br />
                    <div className="f-wb">
                      If you’re complaining on behalf of a business, charity or
                      trust
                    </div>
                    <div style={{ marginBottom: "5px" }}>
                      Please fill in these details
                    </div>

                    <div className="table_resp">
                      <table className="table border" style={{ clear: "both" }}>
                        <tbody>
                          <tr>
                            <td style={{ verticalAlign: "middle" }}>
                              Its full official name
                            </td>
                            <td colSpan={3} />
                          </tr>
                          <tr>
                            <td rowSpan={3} style={{ verticalAlign: "top" }}>
                              What is the status of the business, charity or
                              trust?
                            </td>
                            <td
                              style={{
                                borderRight: "1px solid #fff",
                                borderBottom: "1px solid #fff",
                              }}
                            >
                              <img
                                style={{ marginTop: "15px" }}
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAdCAYAAABSZrcyAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALjSURBVEhLxZY/SHJhFIe/vSEKQw0Cg+gfRCFBQxBEQ1MQhIZDOTjU0NSSWEiFRVtRREQQpBAJNdjaoEmDBIEQBQpBTUYFQWVQkb+PczqfdfOa11S+Z3t/Xu/z3nvf97znD/4jmuUvLy84Pj7G2toaXC4XJiYmMDMzg93dXVxdXclV+ZFTfnp6ipGREZSXl6O1tRUOhwMejwcLCwuYmppCX18fDAYDmpubsbq6isfHR/lnbrLK6SYkNRqNmJ2dxfX1tfyiTjAYxMDAAKqrqxEIBCT9GVX5+fk5amtr+SkfHh4k1cbR0RHq6up44u/v75KqkyEnMc3e6/VKkj9PT0/o6enB0NDQjxNQyO/v71FTUwOfzyfJ73l+fkZ3dzecTqckmSjkNNOxsTEZFc7NzQ0vxkgkIomStJy+FX3nZDIpSXHw+/0wm80yUpKWW61WLC8vy6h4pFIp1NfX88N9h+W3t7eoqKjIe2VrZWlpiT/pd1i+v7+P3t5eDkpBLBaDyWSS0Scsd7vdmJyc5KAU0KunCnl3dyfJByynV1LIvtZCe3s7nw1fYfng4CB2dnY4KBWdnZ0Zi47ldrsdm5ubHJSKtrY2nJycyOgDls/Pz2N8fJyDUvD29oaysrKM3cTyg4MDdHV1cVAKotEompqaZPQJy2lGtM8TiQSHxYZ2k1rZZjkxOjqK6elpGRWP19dX7gnOzs4k+SQtp6NUr9fnbBryZXFxMWsBS8sJ6s36+/tlVDhU2XQ6HS4uLiRRopBTk0gnUDGqHa2fhoYGrK+vS5KJQk7QIdPS0sJNQK42KBuXl5dobGzE3NycJOpkyAmaAHUhVJXi8bik2tjY2EBVVZWm41lVTtBhsLKygsrKSlgsFoRCIS4WatCBQdfSXu7o6FBd2Wpklf+DagDdmMojVSm6uc1mw/DwMC9O6n7oxKJm5PDwUP6ljZzyr1BXGg6Hsb29ja2tLezt7fGKprf0G/KSFxfgL6JcFKOHO80gAAAAAElFTkSuQmCC"
                                alt=""
                              />
                              Limited company
                            </td>
                            <td
                              style={{ borderBottom: "1px solid #fff" }}
                              colSpan={2}
                            >
                              <img
                                style={{ marginTop: "15px" }}
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAdCAYAAABSZrcyAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALjSURBVEhLxZY/SHJhFIe/vSEKQw0Cg+gfRCFBQxBEQ1MQhIZDOTjU0NSSWEiFRVtRREQQpBAJNdjaoEmDBIEQBQpBTUYFQWVQkb+PczqfdfOa11S+Z3t/Xu/z3nvf97znD/4jmuUvLy84Pj7G2toaXC4XJiYmMDMzg93dXVxdXclV+ZFTfnp6ipGREZSXl6O1tRUOhwMejwcLCwuYmppCX18fDAYDmpubsbq6isfHR/lnbrLK6SYkNRqNmJ2dxfX1tfyiTjAYxMDAAKqrqxEIBCT9GVX5+fk5amtr+SkfHh4k1cbR0RHq6up44u/v75KqkyEnMc3e6/VKkj9PT0/o6enB0NDQjxNQyO/v71FTUwOfzyfJ73l+fkZ3dzecTqckmSjkNNOxsTEZFc7NzQ0vxkgkIomStJy+FX3nZDIpSXHw+/0wm80yUpKWW61WLC8vy6h4pFIp1NfX88N9h+W3t7eoqKjIe2VrZWlpiT/pd1i+v7+P3t5eDkpBLBaDyWSS0Scsd7vdmJyc5KAU0KunCnl3dyfJByynV1LIvtZCe3s7nw1fYfng4CB2dnY4KBWdnZ0Zi47ldrsdm5ubHJSKtrY2nJycyOgDls/Pz2N8fJyDUvD29oaysrKM3cTyg4MDdHV1cVAKotEompqaZPQJy2lGtM8TiQSHxYZ2k1rZZjkxOjqK6elpGRWP19dX7gnOzs4k+SQtp6NUr9fnbBryZXFxMWsBS8sJ6s36+/tlVDhU2XQ6HS4uLiRRopBTk0gnUDGqHa2fhoYGrK+vS5KJQk7QIdPS0sJNQK42KBuXl5dobGzE3NycJOpkyAmaAHUhVJXi8bik2tjY2EBVVZWm41lVTtBhsLKygsrKSlgsFoRCIS4WatCBQdfSXu7o6FBd2Wpklf+DagDdmMojVSm6uc1mw/DwMC9O6n7oxKJm5PDwUP6ljZzyr1BXGg6Hsb29ja2tLezt7fGKprf0G/KSFxfgL6JcFKOHO80gAAAAAElFTkSuQmCC"
                                alt=""
                              />
                              Sole proprietor
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                borderRight: "1px solid #fff",
                                borderBottom: "1px solid #fff",
                              }}
                            >
                              <img
                                style={{ marginTop: "15px" }}
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAdCAYAAABSZrcyAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALjSURBVEhLxZY/SHJhFIe/vSEKQw0Cg+gfRCFBQxBEQ1MQhIZDOTjU0NSSWEiFRVtRREQQpBAJNdjaoEmDBIEQBQpBTUYFQWVQkb+PczqfdfOa11S+Z3t/Xu/z3nvf97znD/4jmuUvLy84Pj7G2toaXC4XJiYmMDMzg93dXVxdXclV+ZFTfnp6ipGREZSXl6O1tRUOhwMejwcLCwuYmppCX18fDAYDmpubsbq6isfHR/lnbrLK6SYkNRqNmJ2dxfX1tfyiTjAYxMDAAKqrqxEIBCT9GVX5+fk5amtr+SkfHh4k1cbR0RHq6up44u/v75KqkyEnMc3e6/VKkj9PT0/o6enB0NDQjxNQyO/v71FTUwOfzyfJ73l+fkZ3dzecTqckmSjkNNOxsTEZFc7NzQ0vxkgkIomStJy+FX3nZDIpSXHw+/0wm80yUpKWW61WLC8vy6h4pFIp1NfX88N9h+W3t7eoqKjIe2VrZWlpiT/pd1i+v7+P3t5eDkpBLBaDyWSS0Scsd7vdmJyc5KAU0KunCnl3dyfJByynV1LIvtZCe3s7nw1fYfng4CB2dnY4KBWdnZ0Zi47ldrsdm5ubHJSKtrY2nJycyOgDls/Pz2N8fJyDUvD29oaysrKM3cTyg4MDdHV1cVAKotEompqaZPQJy2lGtM8TiQSHxYZ2k1rZZjkxOjqK6elpGRWP19dX7gnOzs4k+SQtp6NUr9fnbBryZXFxMWsBS8sJ6s36+/tlVDhU2XQ6HS4uLiRRopBTk0gnUDGqHa2fhoYGrK+vS5KJQk7QIdPS0sJNQK42KBuXl5dobGzE3NycJOpkyAmaAHUhVJXi8bik2tjY2EBVVZWm41lVTtBhsLKygsrKSlgsFoRCIS4WatCBQdfSXu7o6FBd2Wpklf+DagDdmMojVSm6uc1mw/DwMC9O6n7oxKJm5PDwUP6ljZzyr1BXGg6Hsb29ja2tLezt7fGKprf0G/KSFxfgL6JcFKOHO80gAAAAAElFTkSuQmCC"
                                alt=""
                              />
                              Partnership
                            </td>
                            <td
                              style={{ borderBottom: "1px solid #fff" }}
                              colSpan={2}
                            >
                              <img
                                style={{ marginTop: "15px" }}
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAdCAYAAABSZrcyAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALjSURBVEhLxZY/SHJhFIe/vSEKQw0Cg+gfRCFBQxBEQ1MQhIZDOTjU0NSSWEiFRVtRREQQpBAJNdjaoEmDBIEQBQpBTUYFQWVQkb+PczqfdfOa11S+Z3t/Xu/z3nvf97znD/4jmuUvLy84Pj7G2toaXC4XJiYmMDMzg93dXVxdXclV+ZFTfnp6ipGREZSXl6O1tRUOhwMejwcLCwuYmppCX18fDAYDmpubsbq6isfHR/lnbrLK6SYkNRqNmJ2dxfX1tfyiTjAYxMDAAKqrqxEIBCT9GVX5+fk5amtr+SkfHh4k1cbR0RHq6up44u/v75KqkyEnMc3e6/VKkj9PT0/o6enB0NDQjxNQyO/v71FTUwOfzyfJ73l+fkZ3dzecTqckmSjkNNOxsTEZFc7NzQ0vxkgkIomStJy+FX3nZDIpSXHw+/0wm80yUpKWW61WLC8vy6h4pFIp1NfX88N9h+W3t7eoqKjIe2VrZWlpiT/pd1i+v7+P3t5eDkpBLBaDyWSS0Scsd7vdmJyc5KAU0KunCnl3dyfJByynV1LIvtZCe3s7nw1fYfng4CB2dnY4KBWdnZ0Zi47ldrsdm5ubHJSKtrY2nJycyOgDls/Pz2N8fJyDUvD29oaysrKM3cTyg4MDdHV1cVAKotEompqaZPQJy2lGtM8TiQSHxYZ2k1rZZjkxOjqK6elpGRWP19dX7gnOzs4k+SQtp6NUr9fnbBryZXFxMWsBS8sJ6s36+/tlVDhU2XQ6HS4uLiRRopBTk0gnUDGqHa2fhoYGrK+vS5KJQk7QIdPS0sJNQK42KBuXl5dobGzE3NycJOpkyAmaAHUhVJXi8bik2tjY2EBVVZWm41lVTtBhsLKygsrKSlgsFoRCIS4WatCBQdfSXu7o6FBd2Wpklf+DagDdmMojVSm6uc1mw/DwMC9O6n7oxKJm5PDwUP6ljZzyr1BXGg6Hsb29ja2tLezt7fGKprf0G/KSFxfgL6JcFKOHO80gAAAAAElFTkSuQmCC"
                                alt=""
                              />
                              Charity
                            </td>
                          </tr>
                          <tr>
                            <td style={{ borderRight: "1px solid #fff" }}>
                              <img
                                style={{ marginTop: "15px" }}
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAdCAYAAABSZrcyAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALjSURBVEhLxZY/SHJhFIe/vSEKQw0Cg+gfRCFBQxBEQ1MQhIZDOTjU0NSSWEiFRVtRREQQpBAJNdjaoEmDBIEQBQpBTUYFQWVQkb+PczqfdfOa11S+Z3t/Xu/z3nvf97znD/4jmuUvLy84Pj7G2toaXC4XJiYmMDMzg93dXVxdXclV+ZFTfnp6ipGREZSXl6O1tRUOhwMejwcLCwuYmppCX18fDAYDmpubsbq6isfHR/lnbrLK6SYkNRqNmJ2dxfX1tfyiTjAYxMDAAKqrqxEIBCT9GVX5+fk5amtr+SkfHh4k1cbR0RHq6up44u/v75KqkyEnMc3e6/VKkj9PT0/o6enB0NDQjxNQyO/v71FTUwOfzyfJ73l+fkZ3dzecTqckmSjkNNOxsTEZFc7NzQ0vxkgkIomStJy+FX3nZDIpSXHw+/0wm80yUpKWW61WLC8vy6h4pFIp1NfX88N9h+W3t7eoqKjIe2VrZWlpiT/pd1i+v7+P3t5eDkpBLBaDyWSS0Scsd7vdmJyc5KAU0KunCnl3dyfJByynV1LIvtZCe3s7nw1fYfng4CB2dnY4KBWdnZ0Zi47ldrsdm5ubHJSKtrY2nJycyOgDls/Pz2N8fJyDUvD29oaysrKM3cTyg4MDdHV1cVAKotEompqaZPQJy2lGtM8TiQSHxYZ2k1rZZjkxOjqK6elpGRWP19dX7gnOzs4k+SQtp6NUr9fnbBryZXFxMWsBS8sJ6s36+/tlVDhU2XQ6HS4uLiRRopBTk0gnUDGqHa2fhoYGrK+vS5KJQk7QIdPS0sJNQK42KBuXl5dobGzE3NycJOpkyAmaAHUhVJXi8bik2tjY2EBVVZWm41lVTtBhsLKygsrKSlgsFoRCIS4WatCBQdfSXu7o6FBd2Wpklf+DagDdmMojVSm6uc1mw/DwMC9O6n7oxKJm5PDwUP6ljZzyr1BXGg6Hsb29ja2tLezt7fGKprf0G/KSFxfgL6JcFKOHO80gAAAAAElFTkSuQmCC"
                                alt=""
                              />
                              Trust
                            </td>
                            <td style={{}} colSpan={2}>
                              <img
                                style={{ marginTop: "15px" }}
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAdCAYAAABSZrcyAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALjSURBVEhLxZY/SHJhFIe/vSEKQw0Cg+gfRCFBQxBEQ1MQhIZDOTjU0NSSWEiFRVtRREQQpBAJNdjaoEmDBIEQBQpBTUYFQWVQkb+PczqfdfOa11S+Z3t/Xu/z3nvf97znD/4jmuUvLy84Pj7G2toaXC4XJiYmMDMzg93dXVxdXclV+ZFTfnp6ipGREZSXl6O1tRUOhwMejwcLCwuYmppCX18fDAYDmpubsbq6isfHR/lnbrLK6SYkNRqNmJ2dxfX1tfyiTjAYxMDAAKqrqxEIBCT9GVX5+fk5amtr+SkfHh4k1cbR0RHq6up44u/v75KqkyEnMc3e6/VKkj9PT0/o6enB0NDQjxNQyO/v71FTUwOfzyfJ73l+fkZ3dzecTqckmSjkNNOxsTEZFc7NzQ0vxkgkIomStJy+FX3nZDIpSXHw+/0wm80yUpKWW61WLC8vy6h4pFIp1NfX88N9h+W3t7eoqKjIe2VrZWlpiT/pd1i+v7+P3t5eDkpBLBaDyWSS0Scsd7vdmJyc5KAU0KunCnl3dyfJByynV1LIvtZCe3s7nw1fYfng4CB2dnY4KBWdnZ0Zi47ldrsdm5ubHJSKtrY2nJycyOgDls/Pz2N8fJyDUvD29oaysrKM3cTyg4MDdHV1cVAKotEompqaZPQJy2lGtM8TiQSHxYZ2k1rZZjkxOjqK6elpGRWP19dX7gnOzs4k+SQtp6NUr9fnbBryZXFxMWsBS8sJ6s36+/tlVDhU2XQ6HS4uLiRRopBTk0gnUDGqHa2fhoYGrK+vS5KJQk7QIdPS0sJNQK42KBuXl5dobGzE3NycJOpkyAmaAHUhVJXi8bik2tjY2EBVVZWm41lVTtBhsLKygsrKSlgsFoRCIS4WatCBQdfSXu7o6FBd2Wpklf+DagDdmMojVSm6uc1mw/DwMC9O6n7oxKJm5PDwUP6ljZzyr1BXGg6Hsb29ja2tLezt7fGKprf0G/KSFxfgL6JcFKOHO80gAAAAAElFTkSuQmCC"
                                alt=""
                              />
                              LLP
                            </td>
                          </tr>
                          <tr>
                            <td style={{ verticalAlign: "middle" }}>
                              If your business, charity or trust is an <br />
                              organisation, name all the directors/ <br />
                              partners/trustees of this organisation
                            </td>
                            <td colSpan={3} />
                          </tr>
                          <tr>
                            <td style={{ verticalAlign: "middle" }}>
                              Name any staff members who you <br />
                              authorise to represent the organisation <br />
                              (and provide their contact details)
                            </td>
                            <td colSpan={3} />
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div style={{ clear: "both" }} />
                    <table style={{ marginTop: "120px" }}>
                      <tbody>
                        <tr>
                          <td>
                            <div
                              className="sml_text"
                              style={{ verticalAlign: "center" }}
                            >
                              Financial Ombudsman Service – Complaint form
                            </div>
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              verticalAlign: "center",
                            }}
                          >
                            2
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <div className="page-break" />
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <table className="adition_page">
              <tbody>
                <tr>
                  <td>
                    <table className="log_hd">
                      <tbody>
                        <tr>
                          <td
                            style={{
                              textAlign: "right",
                              verticalAlign: "bottom",
                              fontSize: "12px",
                              paddingBottom: "5px",
                            }}
                          />
                          <td />
                          <td style={{ textAlign: "right" }}>
                            <img
                              src="data:image/png;base64,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"
                              alt=""
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div style={{ clear: "both" }} />
                    <h3 className="text_thre">
                      If you’re complaining on behalf of a business
                    </h3>
                    <div>
                      Please answer all the following questions – we may need to
                      ask you for evidence of this
                    </div>
                    <div className="table_resp">
                      <table className="table border" style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            <td>Number of employees</td>
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td
                              style={{ width: "50px", textAlign: "center" }}
                              colSpan={6}
                            >
                              If a partnership, the <br />
                              number of partners
                            </td>
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                          </tr>
                          <tr>
                            <td>Its annual turnover</td>
                            <td>£</td>
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td
                              style={{ borderBottom: "1px solid #fff" }}
                              colSpan={6}
                            />
                          </tr>
                          <tr>
                            <td>Balance sheet</td>
                            <td>£</td>
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td colSpan={6} />
                          </tr>
                          <tr>
                            <td>
                              Is this business linked <br />
                              to or partnered with another business?
                            </td>
                            <td colSpan={17}>
                              <p style={{ marginTop: "10px" }}>
                                <img
                                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAQRSURBVFhH7ZZZKHVRFMe/d+XBXDyIEG8ikumFFClS4oGkpJR48iBlKmMkSoaEogyJB2VI5iFknodkyJB5nllf/2Xf417Xxb3oe/l+dbrnnr3P+a+99lprrz/0D/kv/k/4kvjV1RUVFxeTs7MzaWlpkbW1NXl6epKXlxc5ODhIz+Lj42lzc1O89Tkfij8/P1NeXh7p6uqSn58ftba20sXFhRh95eHhgcbHxyk2NpbnhoWF0cnJiRhVjUrx7e1tcnNzIxcXF1peXuZn8MDAwADV1NQoXO3t7XR0dMRzYFx0dDSZmJhQZ2cnP1PFu+IQtrCwoJSUFHp6emJXNjQ0UGpqKqWlpbFgfX29dOXm5lJSUhJVVlbS3Nwce6yjo4MMDAyopaVFfFUZJfHz83OysrKirKws/t/d3c0fxp6PjY3R3d0dP5cHBi4uLlJ1dTXPra2t5a0YGhpiAwYHB8VMRZTEIyIi+AKwOjk5mUZGRvj/V1hfX6eMjAwaHR1lo5qamtiL2LK3KIhjlaamprx67C1WMTs7K0a/zvHxMfX39/O72IKQkBCKi4sTo68oiPv6+lJpaSmLY8V9fX1iRH0Q7VjMwcEBbW1tkY6OjlKmSOJwl56eHl1fX1NPTw9lZmbyvn2Hqakpmp6e5vuAgAAqKiriexmSOFYcGhrKbkL0trW1iRHN2d/f59Xf3NxwEPr7+4uRFyTxyMhIys/Pp5WVFd7rw8NDMaI5WAgifW1tjVZXVzn35ZHEXV1d2crh4WEpzX6CmZkZzn2AMox4kiGJ29nZcXr8prihoSHt7e3xPZDEHR0duSj8pjgiXn47JfHAwECqqqrigpKeni6efh9E+/z8POe+trY2Fx4ZkjhWGxMTw25BwCFIvsv9/T319vbyWYHDx93dXYy8IImjotnY2PA90q6uro7vvwOKC8RRL1DhcN7LI4kDiHd1ddHExASfaJeXl2JEM7CFS0tLnOf6+vqcbvIoiBcWFnJ3AkuxDTg6kauasLGxwamLklpQUEA+Pj5i5BUFceyRra0tlZeX88s4vycnJ9U2YHd3l4XhdsQOyvbCwoIYfUVBHCA64SK0RfgI6jzS5fb2VsxQzePjI4tBGL8oKOjxcnJyxAxFlMQBzmAjIyM24PT0lIMRH8QRiXbprSfgWrRaOAVhLKL77OyMnJycKCoqSsxS5l1xAAPgATSQWBFSEMbACEQwhGQXnqE4od3C1uG/mZkZN5QfoVIcIDrRQNrb23MBQguFDNjZ2eHVyS4UEIAGIigoiIyNjam5uZmffcSH4kDWCnl4eHBb7O3tTYmJiVRSUkJlZWWUnZ1NwcHBZG5uTpaWluwpuPwrfCouD1bZ2NhICQkJ3OeFh4ezaysqKqSWSR3UEv9ZiP4CXeOw9HChGPoAAAAASUVORK5CYII="
                                  alt=""
                                />
                                Yes &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <img
                                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAQRSURBVFhH7ZZZKHVRFMe/d+XBXDyIEG8ikumFFClS4oGkpJR48iBlKmMkSoaEogyJB2VI5iFknodkyJB5nllf/2Xf417Xxb3oe/l+dbrnnr3P+a+99lprrz/0D/kv/k/4kvjV1RUVFxeTs7MzaWlpkbW1NXl6epKXlxc5ODhIz+Lj42lzc1O89Tkfij8/P1NeXh7p6uqSn58ftba20sXFhRh95eHhgcbHxyk2NpbnhoWF0cnJiRhVjUrx7e1tcnNzIxcXF1peXuZn8MDAwADV1NQoXO3t7XR0dMRzYFx0dDSZmJhQZ2cnP1PFu+IQtrCwoJSUFHp6emJXNjQ0UGpqKqWlpbFgfX29dOXm5lJSUhJVVlbS3Nwce6yjo4MMDAyopaVFfFUZJfHz83OysrKirKws/t/d3c0fxp6PjY3R3d0dP5cHBi4uLlJ1dTXPra2t5a0YGhpiAwYHB8VMRZTEIyIi+AKwOjk5mUZGRvj/V1hfX6eMjAwaHR1lo5qamtiL2LK3KIhjlaamprx67C1WMTs7K0a/zvHxMfX39/O72IKQkBCKi4sTo68oiPv6+lJpaSmLY8V9fX1iRH0Q7VjMwcEBbW1tkY6OjlKmSOJwl56eHl1fX1NPTw9lZmbyvn2Hqakpmp6e5vuAgAAqKiriexmSOFYcGhrKbkL0trW1iRHN2d/f59Xf3NxwEPr7+4uRFyTxyMhIys/Pp5WVFd7rw8NDMaI5WAgifW1tjVZXVzn35ZHEXV1d2crh4WEpzX6CmZkZzn2AMox4kiGJ29nZcXr8prihoSHt7e3xPZDEHR0duSj8pjgiXn47JfHAwECqqqrigpKeni6efh9E+/z8POe+trY2Fx4ZkjhWGxMTw25BwCFIvsv9/T319vbyWYHDx93dXYy8IImjotnY2PA90q6uro7vvwOKC8RRL1DhcN7LI4kDiHd1ddHExASfaJeXl2JEM7CFS0tLnOf6+vqcbvIoiBcWFnJ3AkuxDTg6kauasLGxwamLklpQUEA+Pj5i5BUFceyRra0tlZeX88s4vycnJ9U2YHd3l4XhdsQOyvbCwoIYfUVBHCA64SK0RfgI6jzS5fb2VsxQzePjI4tBGL8oKOjxcnJyxAxFlMQBzmAjIyM24PT0lIMRH8QRiXbprSfgWrRaOAVhLKL77OyMnJycKCoqSsxS5l1xAAPgATSQWBFSEMbACEQwhGQXnqE4od3C1uG/mZkZN5QfoVIcIDrRQNrb23MBQguFDNjZ2eHVyS4UEIAGIigoiIyNjam5uZmffcSH4kDWCnl4eHBb7O3tTYmJiVRSUkJlZWWUnZ1NwcHBZG5uTpaWluwpuPwrfCouD1bZ2NhICQkJ3OeFh4ezaysqKqSWSR3UEv9ZiP4CXeOw9HChGPoAAAAASUVORK5CYII="
                                  alt=""
                                />
                                No
                              </p>
                              <div>
                                If yes, we’ll ask you for more information to
                                ensure we’re able to look into this complaint
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              List the businesses <br />
                              linked to or partnered
                            </td>
                            <td colSpan={17} />
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <h3 className="text_thre">
                      If you’re complaining on behalf of a charity or trust
                    </h3>
                    <div>Please answer the relevant following questions</div>
                    <br />

                    <div className="table_resp">
                      <table className="table border">
                        <tbody>
                          <tr>
                            <td style={{ width: "300px" }}>
                              Annual income <br />
                              (if you’re complaining on behalf of a charity
                            </td>
                            <td>£</td>
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                          </tr>
                          <tr>
                            <td>
                              Net assets <br />
                              (if you’re complaining on behalf of a trust)
                            </td>
                            <td>£</td>
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <br />
                    <br />
                    <h2
                      className="text_one color_one"
                      style={{ marginBottom: "8px" }}
                    >
                      The business you’re complaining about
                    </h2>
                    <div className="f-wb" style={{ marginBottom: "8px" }}>
                      Which financial business are you complaining about?
                    </div>
                    <table className="border table">
                      <tbody>
                        <tr>
                          <td
                            style={{
                              width: "300px",
                              borderBottom: "1px solid #fff",
                            }}
                          >
                            Their name
                          </td>
                          <td>Moneybarn 1 Ltd</td>
                        </tr>
                        <tr>
                          <td>
                            Their address
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                          </td>
                          <td>
                            The New Barn,
                            <br />
                            Bedford Road,
                            <br />
                            Petersfield,
                            <br />
                            Hampshire,
                            <br />
                            GU32 3LJ
                            <br />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                    <br />
                    <br />
                    <h2
                      className="text_one color_one"
                      style={{ marginBottom: "8px" }}
                    >
                      What’s happened so far
                    </h2>
                    <table className="border table">
                      <tbody>
                        <tr>
                          <td>Have you already complained to the business?</td>
                          <td colSpan={8}>
                            <p style={{ marginTop: "10px" }}>
                              <img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAQRSURBVFhH7ZZZKHVRFMe/d+XBXDyIEG8ikumFFClS4oGkpJR48iBlKmMkSoaEogyJB2VI5iFknodkyJB5nllf/2Xf417Xxb3oe/l+dbrnnr3P+a+99lprrz/0D/kv/k/4kvjV1RUVFxeTs7MzaWlpkbW1NXl6epKXlxc5ODhIz+Lj42lzc1O89Tkfij8/P1NeXh7p6uqSn58ftba20sXFhRh95eHhgcbHxyk2NpbnhoWF0cnJiRhVjUrx7e1tcnNzIxcXF1peXuZn8MDAwADV1NQoXO3t7XR0dMRzYFx0dDSZmJhQZ2cnP1PFu+IQtrCwoJSUFHp6emJXNjQ0UGpqKqWlpbFgfX29dOXm5lJSUhJVVlbS3Nwce6yjo4MMDAyopaVFfFUZJfHz83OysrKirKws/t/d3c0fxp6PjY3R3d0dP5cHBi4uLlJ1dTXPra2t5a0YGhpiAwYHB8VMRZTEIyIi+AKwOjk5mUZGRvj/V1hfX6eMjAwaHR1lo5qamtiL2LK3KIhjlaamprx67C1WMTs7K0a/zvHxMfX39/O72IKQkBCKi4sTo68oiPv6+lJpaSmLY8V9fX1iRH0Q7VjMwcEBbW1tkY6OjlKmSOJwl56eHl1fX1NPTw9lZmbyvn2Hqakpmp6e5vuAgAAqKiriexmSOFYcGhrKbkL0trW1iRHN2d/f59Xf3NxwEPr7+4uRFyTxyMhIys/Pp5WVFd7rw8NDMaI5WAgifW1tjVZXVzn35ZHEXV1d2crh4WEpzX6CmZkZzn2AMox4kiGJ29nZcXr8prihoSHt7e3xPZDEHR0duSj8pjgiXn47JfHAwECqqqrigpKeni6efh9E+/z8POe+trY2Fx4ZkjhWGxMTw25BwCFIvsv9/T319vbyWYHDx93dXYy8IImjotnY2PA90q6uro7vvwOKC8RRL1DhcN7LI4kDiHd1ddHExASfaJeXl2JEM7CFS0tLnOf6+vqcbvIoiBcWFnJ3AkuxDTg6kauasLGxwamLklpQUEA+Pj5i5BUFceyRra0tlZeX88s4vycnJ9U2YHd3l4XhdsQOyvbCwoIYfUVBHCA64SK0RfgI6jzS5fb2VsxQzePjI4tBGL8oKOjxcnJyxAxFlMQBzmAjIyM24PT0lIMRH8QRiXbprSfgWrRaOAVhLKL77OyMnJycKCoqSsxS5l1xAAPgATSQWBFSEMbACEQwhGQXnqE4od3C1uG/mZkZN5QfoVIcIDrRQNrb23MBQguFDNjZ2eHVyS4UEIAGIigoiIyNjam5uZmffcSH4kDWCnl4eHBb7O3tTYmJiVRSUkJlZWWUnZ1NwcHBZG5uTpaWluwpuPwrfCouD1bZ2NhICQkJ3OeFh4ezaysqKqSWSR3UEv9ZiP4CXeOw9HChGPoAAAAASUVORK5CYII="
                                alt=""
                              />
                              Yes &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAQRSURBVFhH7ZZZKHVRFMe/d+XBXDyIEG8ikumFFClS4oGkpJR48iBlKmMkSoaEogyJB2VI5iFknodkyJB5nllf/2Xf417Xxb3oe/l+dbrnnr3P+a+99lprrz/0D/kv/k/4kvjV1RUVFxeTs7MzaWlpkbW1NXl6epKXlxc5ODhIz+Lj42lzc1O89Tkfij8/P1NeXh7p6uqSn58ftba20sXFhRh95eHhgcbHxyk2NpbnhoWF0cnJiRhVjUrx7e1tcnNzIxcXF1peXuZn8MDAwADV1NQoXO3t7XR0dMRzYFx0dDSZmJhQZ2cnP1PFu+IQtrCwoJSUFHp6emJXNjQ0UGpqKqWlpbFgfX29dOXm5lJSUhJVVlbS3Nwce6yjo4MMDAyopaVFfFUZJfHz83OysrKirKws/t/d3c0fxp6PjY3R3d0dP5cHBi4uLlJ1dTXPra2t5a0YGhpiAwYHB8VMRZTEIyIi+AKwOjk5mUZGRvj/V1hfX6eMjAwaHR1lo5qamtiL2LK3KIhjlaamprx67C1WMTs7K0a/zvHxMfX39/O72IKQkBCKi4sTo68oiPv6+lJpaSmLY8V9fX1iRH0Q7VjMwcEBbW1tkY6OjlKmSOJwl56eHl1fX1NPTw9lZmbyvn2Hqakpmp6e5vuAgAAqKiriexmSOFYcGhrKbkL0trW1iRHN2d/f59Xf3NxwEPr7+4uRFyTxyMhIys/Pp5WVFd7rw8NDMaI5WAgifW1tjVZXVzn35ZHEXV1d2crh4WEpzX6CmZkZzn2AMox4kiGJ29nZcXr8prihoSHt7e3xPZDEHR0duSj8pjgiXn47JfHAwECqqqrigpKeni6efh9E+/z8POe+trY2Fx4ZkjhWGxMTw25BwCFIvsv9/T319vbyWYHDx93dXYy8IImjotnY2PA90q6uro7vvwOKC8RRL1DhcN7LI4kDiHd1ddHExASfaJeXl2JEM7CFS0tLnOf6+vqcbvIoiBcWFnJ3AkuxDTg6kauasLGxwamLklpQUEA+Pj5i5BUFceyRra0tlZeX88s4vycnJ9U2YHd3l4XhdsQOyvbCwoIYfUVBHCA64SK0RfgI6jzS5fb2VsxQzePjI4tBGL8oKOjxcnJyxAxFlMQBzmAjIyM24PT0lIMRH8QRiXbprSfgWrRaOAVhLKL77OyMnJycKCoqSsxS5l1xAAPgATSQWBFSEMbACEQwhGQXnqE4od3C1uG/mZkZN5QfoVIcIDrRQNrb23MBQguFDNjZ2eHVyS4UEIAGIigoiIyNjam5uZmffcSH4kDWCnl4eHBb7O3tTYmJiVRSUkJlZWWUnZ1NwcHBZG5uTpaWluwpuPwrfCouD1bZ2NhICQkJ3OeFh4ezaysqKqSWSR3UEv9ZiP4CXeOw9HChGPoAAAAASUVORK5CYII="
                                alt=""
                              />
                              No
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <br />
                            If yes, when did you complain to the business? (The
                            business
                            <br />
                            usually has up to eight weeks from this date to send
                            you its final <br />
                            written answer – before we can investigate the
                            complaint)
                          </td>
                          <td style={{ verticalAlign: "bottom" }}>D</td>
                          <td style={{ verticalAlign: "bottom" }}>D</td>
                          <td style={{ verticalAlign: "bottom" }}>M</td>
                          <td style={{ verticalAlign: "bottom" }}>M</td>
                          <td style={{ verticalAlign: "bottom" }}>Y</td>
                          <td style={{ verticalAlign: "bottom" }}>Y</td>
                          <td style={{ verticalAlign: "bottom" }}>Y</td>
                          <td style={{ verticalAlign: "bottom" }}>Y</td>
                        </tr>
                      </tbody>
                    </table>
                    <div style={{ clear: "both" }} />
                    <table style={{ marginTop: "80px" }}>
                      <tbody>
                        <tr>
                          <td>
                            <div
                              className="sml_text"
                              style={{ verticalAlign: "center" }}
                            >
                              Financial Ombudsman Service – Complaint form
                            </div>
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              verticalAlign: "center",
                            }}
                          >
                            3
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <div className="page-break" />
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <table className="adition_page">
              <tbody>
                <tr>
                  <td>
                    <table className="log_hd">
                      <tbody>
                        <tr>
                          <td
                            style={{
                              textAlign: "right",
                              verticalAlign: "bottom",
                              fontSize: "12px",
                              paddingBottom: "5px",
                            }}
                          />
                          <td />
                          <td style={{ textAlign: "right" }}>
                            <img
                              src="data:image/png;base64,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"
                              alt=""
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    {/* Header */}
                    <div style={{ clear: "both" }} />
                    <br />
                    <br />
                    <div className="table_resp">
                      <table className="border table" style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            <td>
                              Has the business you’re complaining about sent you
                              its final written <br />
                              answer? If yes, please send us a copy
                            </td>
                            <td colSpan={8}>
                              <p style={{ marginTop: "10px" }}>
                                <img
                                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAdCAYAAABSZrcyAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALjSURBVEhLxZY/SHJhFIe/vSEKQw0Cg+gfRCFBQxBEQ1MQhIZDOTjU0NSSWEiFRVtRREQQpBAJNdjaoEmDBIEQBQpBTUYFQWVQkb+PczqfdfOa11S+Z3t/Xu/z3nvf97znD/4jmuUvLy84Pj7G2toaXC4XJiYmMDMzg93dXVxdXclV+ZFTfnp6ipGREZSXl6O1tRUOhwMejwcLCwuYmppCX18fDAYDmpubsbq6isfHR/lnbrLK6SYkNRqNmJ2dxfX1tfyiTjAYxMDAAKqrqxEIBCT9GVX5+fk5amtr+SkfHh4k1cbR0RHq6up44u/v75KqkyEnMc3e6/VKkj9PT0/o6enB0NDQjxNQyO/v71FTUwOfzyfJ73l+fkZ3dzecTqckmSjkNNOxsTEZFc7NzQ0vxkgkIomStJy+FX3nZDIpSXHw+/0wm80yUpKWW61WLC8vy6h4pFIp1NfX88N9h+W3t7eoqKjIe2VrZWlpiT/pd1i+v7+P3t5eDkpBLBaDyWSS0Scsd7vdmJyc5KAU0KunCnl3dyfJByynV1LIvtZCe3s7nw1fYfng4CB2dnY4KBWdnZ0Zi47ldrsdm5ubHJSKtrY2nJycyOgDls/Pz2N8fJyDUvD29oaysrKM3cTyg4MDdHV1cVAKotEompqaZPQJy2lGtM8TiQSHxYZ2k1rZZjkxOjqK6elpGRWP19dX7gnOzs4k+SQtp6NUr9fnbBryZXFxMWsBS8sJ6s36+/tlVDhU2XQ6HS4uLiRRopBTk0gnUDGqHa2fhoYGrK+vS5KJQk7QIdPS0sJNQK42KBuXl5dobGzE3NycJOpkyAmaAHUhVJXi8bik2tjY2EBVVZWm41lVTtBhsLKygsrKSlgsFoRCIS4WatCBQdfSXu7o6FBd2Wpklf+DagDdmMojVSm6uc1mw/DwMC9O6n7oxKJm5PDwUP6ljZzyr1BXGg6Hsb29ja2tLezt7fGKprf0G/KSFxfgL6JcFKOHO80gAAAAAElFTkSuQmCC"
                                  alt=""
                                />
                                Yes &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <img
                                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAgCAYAAADqgqNBAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAQVSURBVFhH7ZZLSGNXGMdzLbZTJ7FgfWFVWkWlalUcatqMtosiCAoVXwiOgqgLF9VakCx04qtjxQcVF25EQSzoqIuiWFe1FoYG0zDJVKUoUiRO8TV1QnVMgo9/c06+iTeaxBtbmE1/EJLvuzf53XPyne8cGV4h/8slcXJyAoPBgKGhITQ3N0OtVqOlpQUTExPY2Nigu6QjSc5+uKGhAUFBQUhMTERFRQU6OjrQ1dUFjUaDgoICREVFISYmBj09PTg4OKBveser3Gq18tGFhITw983NTbrinqWlJZSXl/P7R0dHKesZj3KTyYTk5GQUFhZib2+PstIwGo1ISUlBUVERH4An3MqZODY2Fr29vZTxHZvNhpKSEuTm5np8gCtydmNSUhL6+vooc3NYgbLRV1ZWUsaVK/LGxkYUFxdTdEOsf8G0bcaZ/ePR0REvxNnZWcc1ES7ytbU1hIaGYn9/nzK+8eL3h1B/noaIdz5F+y9mygKLi4uIjo7G6ekpZRy4yOvq6tDU1ESRb5w9fYh77/pD8H8PFdN/8lGLyczMxPT0NEUOnHJWIGwdb21tUcYHbCv49rO34SfcwgdfLeA5pcWwRpSdnU2RA6dcp9MhNTWVIl+wwth5FwpBwO0PNdBZKH0Js9kMhUKBs7OLOXHKBwcHUVVVRZF0rIYHUCkECHIl2vUezERcXBxWVlYoEslZlXd3d1MkEasBX3+sgCAooHpgsM+Bd/Ly8jAzM0ORSF5fX4/+/n6KpGDF4/aPIBf8EJjVhd9slPYC65bionPKWe/u7OykyA0WE7Tf/4Anzx3/meXXNihvC/AL/ATdyxLMdnJycjA3N0eRSD4yMoKysjKKLmF9hPvpgfZq9kdqsx62F1rcvxPAp/vuN08gTQ1ERka6bL1O+fLyMhISEii6hGUWlWF+kMlkeC0yH1/eex+3WHUr2/H4uj+a2NnZ4UtZjFPOlkBERARWV1cpI+YZRvPfgmCXswdgL+HNO9Asea9uMWw1sT4vxilntLa2ora2liJXnn1XiCA/kgtvIEX9CEd0TQpss1pYWKDIgYt8e3sbwcHBWF9fp4yIowV8EWdvnzIBryc2YPFvyktgfHwcaWlpFF3gImcMDAxApVK5dKKXHP6hw08//gzjU+nTzQYUFhYGvV5PmQuuyM/Pz3kPrqmp4Z//DaylZmRkoK2tjTKuXJEzDg8PkZWVherqar7h3ITd3V0uZs3LE27lDPYA+fn5/CzGjsu+MDU1hfDwcH6s9oZH+UvGxsb4AYOdxebn5z2ex9gUs0aVnp7OK5udZK/jWjnj+PgYw8PDUCqVCAgI4ILS0lJ+fmf9Oj4+HnK5nG8c7AGl1ookuRiLxQKtVsuXDzubT05O8m3S3eq4Dp/l/yWvUA78A6yDDm3QxQl2AAAAAElFTkSuQmCC"
                                  alt=""
                                />
                                No
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ borderBottom: "1px solid #fff" }}>
                              Has there been any court action relating to your
                              complaint
                              <br />
                              (or is any planned)? If yes, please enclose copies
                              of relevant paperwork
                            </td>
                            <td colSpan={8}>
                              <p style={{ marginTop: "10px", width: "250px" }}>
                                <img
                                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAdCAYAAABSZrcyAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALjSURBVEhLxZY/SHJhFIe/vSEKQw0Cg+gfRCFBQxBEQ1MQhIZDOTjU0NSSWEiFRVtRREQQpBAJNdjaoEmDBIEQBQpBTUYFQWVQkb+PczqfdfOa11S+Z3t/Xu/z3nvf97znD/4jmuUvLy84Pj7G2toaXC4XJiYmMDMzg93dXVxdXclV+ZFTfnp6ipGREZSXl6O1tRUOhwMejwcLCwuYmppCX18fDAYDmpubsbq6isfHR/lnbrLK6SYkNRqNmJ2dxfX1tfyiTjAYxMDAAKqrqxEIBCT9GVX5+fk5amtr+SkfHh4k1cbR0RHq6up44u/v75KqkyEnMc3e6/VKkj9PT0/o6enB0NDQjxNQyO/v71FTUwOfzyfJ73l+fkZ3dzecTqckmSjkNNOxsTEZFc7NzQ0vxkgkIomStJy+FX3nZDIpSXHw+/0wm80yUpKWW61WLC8vy6h4pFIp1NfX88N9h+W3t7eoqKjIe2VrZWlpiT/pd1i+v7+P3t5eDkpBLBaDyWSS0Scsd7vdmJyc5KAU0KunCnl3dyfJByynV1LIvtZCe3s7nw1fYfng4CB2dnY4KBWdnZ0Zi47ldrsdm5ubHJSKtrY2nJycyOgDls/Pz2N8fJyDUvD29oaysrKM3cTyg4MDdHV1cVAKotEompqaZPQJy2lGtM8TiQSHxYZ2k1rZZjkxOjqK6elpGRWP19dX7gnOzs4k+SQtp6NUr9fnbBryZXFxMWsBS8sJ6s36+/tlVDhU2XQ6HS4uLiRRopBTk0gnUDGqHa2fhoYGrK+vS5KJQk7QIdPS0sJNQK42KBuXl5dobGzE3NycJOpkyAmaAHUhVJXi8bik2tjY2EBVVZWm41lVTtBhsLKygsrKSlgsFoRCIS4WatCBQdfSXu7o6FBd2Wpklf+DagDdmMojVSm6uc1mw/DwMC9O6n7oxKJm5PDwUP6ljZzyr1BXGg6Hsb29ja2tLezt7fGKprf0G/KSFxfgL6JcFKOHO80gAAAAAElFTkSuQmCC"
                                  alt=""
                                />
                                Yes &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <img
                                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAgCAYAAADqgqNBAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAQVSURBVFhH7ZZLSGNXGMdzLbZTJ7FgfWFVWkWlalUcatqMtosiCAoVXwiOgqgLF9VakCx04qtjxQcVF25EQSzoqIuiWFe1FoYG0zDJVKUoUiRO8TV1QnVMgo9/c06+iTeaxBtbmE1/EJLvuzf53XPyne8cGV4h/8slcXJyAoPBgKGhITQ3N0OtVqOlpQUTExPY2Nigu6QjSc5+uKGhAUFBQUhMTERFRQU6OjrQ1dUFjUaDgoICREVFISYmBj09PTg4OKBveser3Gq18tGFhITw983NTbrinqWlJZSXl/P7R0dHKesZj3KTyYTk5GQUFhZib2+PstIwGo1ISUlBUVERH4An3MqZODY2Fr29vZTxHZvNhpKSEuTm5np8gCtydmNSUhL6+vooc3NYgbLRV1ZWUsaVK/LGxkYUFxdTdEOsf8G0bcaZ/ePR0REvxNnZWcc1ES7ytbU1hIaGYn9/nzK+8eL3h1B/noaIdz5F+y9mygKLi4uIjo7G6ekpZRy4yOvq6tDU1ESRb5w9fYh77/pD8H8PFdN/8lGLyczMxPT0NEUOnHJWIGwdb21tUcYHbCv49rO34SfcwgdfLeA5pcWwRpSdnU2RA6dcp9MhNTWVIl+wwth5FwpBwO0PNdBZKH0Js9kMhUKBs7OLOXHKBwcHUVVVRZF0rIYHUCkECHIl2vUezERcXBxWVlYoEslZlXd3d1MkEasBX3+sgCAooHpgsM+Bd/Ly8jAzM0ORSF5fX4/+/n6KpGDF4/aPIBf8EJjVhd9slPYC65bionPKWe/u7OykyA0WE7Tf/4Anzx3/meXXNihvC/AL/ATdyxLMdnJycjA3N0eRSD4yMoKysjKKLmF9hPvpgfZq9kdqsx62F1rcvxPAp/vuN08gTQ1ERka6bL1O+fLyMhISEii6hGUWlWF+kMlkeC0yH1/eex+3WHUr2/H4uj+a2NnZ4UtZjFPOlkBERARWV1cpI+YZRvPfgmCXswdgL+HNO9Asea9uMWw1sT4vxilntLa2ora2liJXnn1XiCA/kgtvIEX9CEd0TQpss1pYWKDIgYt8e3sbwcHBWF9fp4yIowV8EWdvnzIBryc2YPFvyktgfHwcaWlpFF3gImcMDAxApVK5dKKXHP6hw08//gzjU+nTzQYUFhYGvV5PmQuuyM/Pz3kPrqmp4Z//DaylZmRkoK2tjTKuXJEzDg8PkZWVherqar7h3ITd3V0uZs3LE27lDPYA+fn5/CzGjsu+MDU1hfDwcH6s9oZH+UvGxsb4AYOdxebn5z2ex9gUs0aVnp7OK5udZK/jWjnj+PgYw8PDUCqVCAgI4ILS0lJ+fmf9Oj4+HnK5nG8c7AGl1ookuRiLxQKtVsuXDzubT05O8m3S3eq4Dp/l/yWvUA78A6yDDm3QxQl2AAAAAElFTkSuQmCC"
                                  alt=""
                                />
                                No
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ height: "50px" }}>
                              When did the advice, claim, service or transaction
                              you’re complaining about take place?
                            </td>
                            <td style={{ verticalAlign: "bottom" }}>D</td>
                            <td style={{ verticalAlign: "bottom" }}>D</td>
                            <td style={{ verticalAlign: "bottom" }}>M</td>
                            <td style={{ verticalAlign: "bottom" }}>M</td>
                            <td style={{ verticalAlign: "bottom" }}>Y</td>
                            <td style={{ verticalAlign: "bottom" }}>Y</td>
                            <td style={{ verticalAlign: "bottom" }}>Y</td>
                            <td style={{ verticalAlign: "bottom" }}>Y</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <br />
                    <br />
                    <h2
                      className="text_one color_one"
                      style={{ marginBottom: "8px" }}
                    >
                      Your complaint
                    </h2>
                    <div className="f-wb">
                      Please tell us about the product or service you would like
                      to complain about
                    </div>
                    <div>
                      (including the reference number of the
                      account/policy/product if you have one)
                    </div>
                    <br />
                    <table className="table border">
                      <tbody>
                        <tr>
                          <td
                            style={{
                              borderBottom: "1px solid #fff",
                              borderRight: "1px solid #fff",
                            }}
                          >
                            <div
                              className="f-wb"
                              style={{ borderBottom: "0px" }}
                            >
                              Credit lent by the lender
                            </div>
                            <br />
                            <br />
                            <br />
                            <br />
                          </td>
                          <td />
                        </tr>
                        <tr>
                          <td style={{ width: "50%" }}>
                            Do you have a complaint reference number that <br />
                            the business gave you? If yes, please provide
                          </td>
                          <td />
                        </tr>
                      </tbody>
                    </table>
                    <h3>Tell us about your complaint – what happened?</h3>
                    <div
                      style={{
                        border: "1px solid #000",
                        padding: "5px",
                        height: "200px",
                      }}
                    >
                      <b>
                        Please refer to the complaint points provided in the
                        documentation
                      </b>
                    </div>
                    <div style={{ clear: "both" }} />
                    <table style={{ marginTop: "200px" }}>
                      <tbody>
                        <tr>
                          <td>
                            <div
                              className="sml_text"
                              style={{ verticalAlign: "center" }}
                            >
                              Financial Ombudsman Service – Complaint form
                            </div>
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              verticalAlign: "center",
                            }}
                          >
                            4
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <div className="page-break" />
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
            <table className="adition_page">
              <tbody>
                <tr>
                  <td>
                    <table className="log_hd">
                      <tbody>
                        <tr>
                          <td
                            style={{
                              textAlign: "right",
                              verticalAlign: "bottom",
                              fontSize: "12px",
                              paddingBottom: "5px",
                            }}
                          />
                          <td />
                          <td style={{ textAlign: "right" }}>
                            <img
                              src="data:image/png;base64,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"
                              alt=""
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    {/* header */}
                    <div style={{ clear: "both" }} />
                    <h3>
                      How have you been affected – financially or otherwise?
                    </h3>
                    <div
                      style={{
                        border: "1px solid #000",
                        padding: "10px",
                        height: "200px",
                      }}
                    >
                      <b> I have been financially disadvantaged. </b>
                    </div>
                    <br />
                    <h3>
                      How would you like the business to put things right for
                      you?
                    </h3>
                    <div
                      style={{
                        border: "1px solid #000",
                        padding: "10px",
                        height: "200px",
                      }}
                    >
                      <b>
                        All interest, fees and charges plus 8 % interest. In
                        addition, a distress and inconvenience payment for the
                        way they have handled the complaint and the length of
                        time taken/ Furthermore, any secret commission where
                        applic
                      </b>
                    </div>
                    <div>
                      <br />
                      Please continue on a separate sheet if needed. <br />
                      <br />
                      If your complaint is about the sale of payment protection
                      insurance (PPI) or a packaged bank account, you will also
                      need to complete a separate questionnaire. You may have
                      done this already – if you have already complained
                      directly to the business you think is responsible. If not,
                      you can download the questionnaire off our website – or
                      phone us for a copy on 0800 023 4567.
                    </div>
                    <div style={{ clear: "both" }} />
                    <table style={{ marginTop: "230px" }}>
                      <tbody>
                        <tr>
                          <td>
                            <div
                              className="sml_text"
                              style={{ verticalAlign: "center" }}
                            >
                              Financial Ombudsman Service – Complaint form
                            </div>
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              verticalAlign: "center",
                            }}
                          >
                            5
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            {/* /////////////////////////////////PAGE///////////////////////////////// */}
          </section>
          <div
            style={{
              textAlign: "center",
              position: "fixed",
              left: 0,
              right: 0,
              width: "100%",
              bottom: 0,
              backgroundColor: "#212529",
            }}
          >
            <a
              onClick={pushPageChange}
              style={{
                padding: "12px 10px",
                display: "inline-block",
                background: "#198754",
                color: "#fff",
                borderRadius: "10px",
                fontFamily: "arial",
                textDecoration: "none",
                width: "150px",
                margin: "15px 0",
                fontSize: "18px",
                textTransform: "uppercase",
                fontWeight: "bold",
              }}
            >
              Next 🡢
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
export default PreviewV2;
